/**
 * Created by Qingger Corp.
 * User: jsspf
 * Date: 2017/11/21
 * Time: 12:32
 */
import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';
import type { BaseHttpRequestOption } from '@/util/type';
import { HttpMethod } from '@/util/type';

export namespace IPAPIConfig {
  /**
   * 代理地址的路径-
   * @type {string}
   */
  export const API_BASE_URL = '/ips';
  const API_BASE_URL_FOR_NODE = '/nips';
  export const API_BASE_CRM_URL = '/nips/scrm';

  /**
   * 图片服务地址
   * @type {string}
   */
  export const API_IMAGE_URL = '/img';

  function resolveURLConfig(baseURL: string, tOut = 15000) {
    return function(path: string, method = HttpMethod.POST, name = '', options: ItemObject = {}, timeout: number = tOut): BaseHttpRequestOption {
      options.auth = options.auth !== false;

      options.authTokenKey = options.authTokenKey ? options.authTokenKey : null;

      let ret: BaseHttpRequestOption = {
        name,
        baseURL,
        path,
        method,
        timeout,
      };

      ret = merge({}, ret, options);
      if (!isEmpty(ret.name)) {
        ret.fromJson = true;
      }
      return ret;
    };
  }

  function resolveURLTimeConfig(baseURL: string, tOut = 60000) {
    return function(path: string, method = HttpMethod.POST, name = '', options: ItemObject = {}, timeout: number = tOut): BaseHttpRequestOption {
      options.auth = options.auth !== false;

      options.authTokenKey = options.authTokenKey ? options.authTokenKey : null;

      let ret: BaseHttpRequestOption = {
        name,
        baseURL,
        path,
        method,
        timeout,
      };

      ret = merge({}, ret, options);
      if (!isEmpty(ret.name)) {
        ret.fromJson = true;
      }
      return ret;
    };
  }

  /**
   * 生成URLConfig的函数
   * @returns {BaseHttpRequestOption}
   */
  export const resolveIPSURLConfig = resolveURLConfig(API_BASE_URL);

  // 新的Node接口定义
  export const resolveIPSNodeURLConfig = resolveURLConfig(API_BASE_URL_FOR_NODE);
  // 新的Node接口定义
  export const resolveIPSNodeTimeURLConfig = resolveURLTimeConfig(API_BASE_URL_FOR_NODE);

  // 访问crm接口
  export const resolveIPSCRMURLConfig = resolveURLConfig(API_BASE_CRM_URL);

  /**
   * IP店的接口资源定义
   * @type {{}}
   */
  export const APIResURLConfig = {
    /**
     * AS1.编辑尺码对照表数据
     * @see : https://wiki.qingger.cn/pages/viewpage.action?pageId=12748872
     */
    OPERATE_LEVEL_CLASS_SIZE_DESC: resolveIPSURLConfig('/admin/operateLevelClassSizeDesc'),

    /**
     * AS1.网点组列表
     * @see : https://runsa.yuque.com/runsadev/ir5wcy/11403922
     */
    SITE_GROUP_LIST: resolveIPSNodeURLConfig('/admin/getSiteGroupList', HttpMethod.GET),
    /**
     * COM.1 批量查询商品信息
     * @see : https://runsa.yuque.com/runsadev/ir5wcy/xvb26m
     */
    ADMIN_COM_BATCH_FIND_PRODUCTS: resolveIPSNodeURLConfig('/admin/com/batch/find/products', HttpMethod.POST),
    /**
     * COM.2 批量查询版单号关联商品
     * @see : https://runsa.yuque.com/runsadev/ir5wcy/hcp7c8
     */
    ADMIN_COM_BATCH_FIND_BDPRODUCTS: resolveIPSNodeURLConfig('/admin/com/batch/find/bdproducts', HttpMethod.POST),

    /**
     * AS2. 新增/编辑网点组
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS2.md
     */
    UPDATE_SITE_GROUP: resolveIPSNodeURLConfig('/admin/operateSiteGroup'),

    /**
     * AS3. 网点组数据配置保存(基础配置)
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS3.md
     */
    UPDATE_BASIC_CONFIG: resolveIPSURLConfig('/admin/editGroupBasicConfig'),

    /**
     * AS4. 网点组详情
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS4.md
     */
    SITE_GROUP_INFO: resolveIPSURLConfig('/admin/getSiteGroupInfo', HttpMethod.GET),

    /**
     * AS5.组织架构下网点树型列表
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS5.md
     */
    ORG_SITE_TREE_LIST: resolveIPSURLConfig('/admin/getSiteList', HttpMethod.GET),

    /**
     * AS6. 删除网点组
     * @see https://runsa.yuque.com/runsadev/ir5wcy/ga3lpt
     */
    DELETE_SITE_GROUP: resolveIPSNodeURLConfig('/admin/del/siteGroup'),

    /**
     * AS7. 获取网点组信息（网点上带有树型结构的管辖组织信息)
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS7.md
     */
    ORG_SITE_TREE_LIST_BY_SITE_GROUP: resolveIPSURLConfig('/admin/getSiteGroupInfoWithOrg', HttpMethod.GET),
    /**
     * 同上，node方式
     */
    ORG_SITE_TREE_LIST_NODE_BY_SITE_GROUP: resolveIPSNodeURLConfig('/admin/getSiteGroupInfoWithOrg', HttpMethod.POST),

    /**
     *AS61.批量店铺码生成导出
     * @see https://runsa.yuque.com/runsadev/ir5wcy/tmgqyr
     */
    ADMIN_SITE_QRCODE_EXPORT: resolveIPSNodeURLConfig('/admin/site/qrcode/export', HttpMethod.POST),
    /**
     * AS8. 清除网点组的商品缓存
     * @see:https://wiki.qingger.cn/pages/viewpage.action?pageId=11404321
     */
    DELETE_SITE_GROUP_CACHE: resolveIPSNodeURLConfig('/admin/clearGoodsCache'),

    /**
     * AS9. 网点组数据配置详情(基础配置)
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS9.md
     */
    BASIC_CONFIG_INFO: resolveIPSURLConfig('/admin/groupBasicConfig/info', HttpMethod.GET),

    /**
     * AS10. 网点组数据配置保存(页面配置)
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS10.md
     */
    UPDATE_PAGE_CONFIG: resolveIPSURLConfig('/admin/groupPageConfig/edit'),

    /**
     * AS11. 网点组数据配置详情(页面配置)
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS11.md
     */
    PAGE_CONFIG_INFO: resolveIPSURLConfig('/admin/groupPageConfig/info', HttpMethod.GET),

    /**
     * AS16. 网点组数据配置选择(页面配置-期刊列表)
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/README.md
     */
    PERIODICAL_LIST_BY_PAGE_CONFIG: resolveIPSURLConfig('/admin/page/qikanList', HttpMethod.GET),

    /**
     * AS17. 网点组数据配置选择(页面配置-活动列表)
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS17.md
     */
    ACTIVITY_LIST_BY_PAGE_CONFIG: resolveIPSURLConfig('/admin/page/actList', HttpMethod.GET),

    /**
     * AS18. 网点组数据配置选择(页面配置-商品列表)
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS18.md
     */
    GOODS_LIST_BY_PAGE_CONFIG: resolveIPSURLConfig('/admin/page/productInfo', HttpMethod.GET),

    /**
     * AS19. 网点组数据配置选择(页面配置-网点筛选)
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS19.md
     */
    SITE_LIST_BY_PAGE_CONFIG: resolveIPSURLConfig('/admin/page/siteList', HttpMethod.GET),

    /**
     * AS20.根据店铺CODE获取导购列表
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS20.md
     */
    GUIDER_LIST_BY_SITE_CODE: resolveIPSURLConfig('/admin/getGuiderList', HttpMethod.GET),

    COPY_SITE_GROUP_INFO: resolveIPSURLConfig('/admin/copy/sg/list'),

    /**
     * AS24.网点列表
     * @see : http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS1.md
     */
    SITE_ARRAY_INFO: resolveIPSURLConfig('/admin/config/site/list', HttpMethod.GET),

    /**
     * AS69.网点设定列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1052
     */
    SITE_MANAGER: resolveIPSNodeURLConfig('/admin/config/site/list', HttpMethod.POST),

    /**
     * AS25.网点设定详情
     * @see : http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS25.md
     */
    SITE_INFO: resolveIPSURLConfig('/admin/config/site/info', HttpMethod.GET),

    /**
     * AS26.网点设定保存
     * @see : http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS26.md
     */
    SAVE_SITE_EDIT: resolveIPSURLConfig('/admin/config/site/save', HttpMethod.POST),

    /**
     * AS33.获取网点组的商品分类黑名单
     * @see : https://wiki.qingger.cn/pages/viewpage.action?pageId=12747541
     */
    PRODUCT_CLASS_HIDE: resolveIPSURLConfig('/admin/getSiteGroupInfo/productClassHide', HttpMethod.GET),

    /**
     * AS34.保存网点组的商品分类黑名单
     * @see : https://wiki.qingger.cn/pages/viewpage.action?pageId=12747545
     */
    SAVE_SITE_GROUP_PRO_CLASS_HIDE: resolveIPSURLConfig('/admin/saveSiteGroupProClassHide'),

    /**
     * AS35.获取入会配置
     * @see : https://wiki.qingger.cn/pages/viewpage.action?pageId=12747554
     */
    GET_SITE_GROUP_OTHER_CONFIG: resolveIPSNodeURLConfig('/admin/getSiteGroupOtherConfig', HttpMethod.POST),

    /**
     * AS36.保存网点组其他配置
     * @see : https://wiki.qingger.cn/pages/viewpage.action?pageId=12747556
     */
    SAVE_SITE_GROUP_OTHER_CONFIG: resolveIPSNodeURLConfig('/admin/saveSiteGroupOtherConfig', HttpMethod.POST),

    /**
     * AS42. 小程序添加网点列表接口
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=14779057
     */
    SITE_GROUP_SITE_LIST: resolveIPSNodeURLConfig('/admin/siteGroup/site/list'),

    /**
     * AS43.获取集团的开票说明
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=16023662
     */
    INVOICE_NOTE: resolveIPSNodeURLConfig('/admin/invoice/note'),

    /**
     * AS44.更新集团开票说明
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=16023666
     */
    INVOICE_NOTE_SAVE: resolveIPSNodeURLConfig('/admin/invoice/note/save'),

    /**
     * AS45.获取集团最大佣金比例
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=16024579
     */
    MAX_COMMISSION: resolveIPSNodeURLConfig('/admin/max/commission'),

    /**
     * AS46.更新集团最大佣金比例
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=16024581
     */
    MAX_COMMISSION_SAVE: resolveIPSNodeURLConfig('/admin/max/commission/save'),

    /**
     * AS47.获取商品图片取值配置
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=30834705
     */
    PRODUCT_IMAGE_CONFIG: resolveIPSNodeURLConfig('/admin/product/image/config'),

    /**
     * AS46.更新集团最大佣金比例
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=30834707
     */
    PRODUCT_IMAGE_CONFIG_SAVE: resolveIPSNodeURLConfig('/admin/product/image/config/save'),

    /**
     * AS55.更新会员等级相关配置
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=61407251
     */
    ADMIN_MEMBER_LEVEL_CONFIG_SAVE: resolveIPSNodeURLConfig('/admin/member/level/config/save'),

    /**
     * AS56.获取会员等级相关配置
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=61407254
     */
    ADMIN_MEMBER_LEVEL_CONFIG: resolveIPSNodeURLConfig('/admin/member/level/config'),
    /**
     * AS58. 允许店铺销售
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=100204574
     */
    ADMIN_SITE_OPEN: resolveIPSNodeURLConfig('/admin/site/open'),
    /**
     * AS59. 禁止店铺销售
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=100204576
     */
    ADMIN_SITE_CLOSE: resolveIPSNodeURLConfig('/admin/site/close'),

    /**
     * AC1. 新增/编辑分类(层级分类)
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Class_AC1.md
     */
    UPDATE_LEVEL_CLASS: resolveIPSNodeURLConfig('/admin/operateLevelClass'),

    /**
     * AC1. 新增/编辑分类(层级分类)
     */
    UPDATE_LEVEL_NODE_CLASS: resolveIPSNodeURLConfig('/admin/operateLevelClass'),
    /**
     * AC1-1. 新增/编辑分类(标签分类)
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Class_AC1_1.md
     */
    UPDATE_LABEL_CLASS: resolveIPSURLConfig('/admin/operateLabelClass'),

    /**
     * AC2. 禁用/启用/删除分类
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Class_AC2.md
     */
    BATCH_OPERATION_CLASS: resolveIPSNodeURLConfig('/admin/editState'),

    /**
     * AC4. 获取分类列表(层级)
     * @see(old) http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Class_AC4.md
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=12748867
     */
    LEVEL_CLASS_LIST: resolveIPSNodeURLConfig('/admin/levelClassList'),

    /**
     * AC5. 获取分类列表(标签)
     * @see(old) http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Class_AC5.md
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=83329062
     */
    LABEL_CLASS_LIST: resolveIPSNodeURLConfig('/admin/labelClassList', HttpMethod.GET),

    /**
     * AC6. 分类关联属性
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Class_AC6.md
     */
    RELATE_ATTRIBUTE_OF_CLASS: resolveIPSNodeURLConfig('/admin/relateAttribute'),

    /**
     * AC7. 获取属性列表y
     * @see(old) http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Class_AC7.md
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=83329069
     */
    ATTRIBUTE_LIST: resolveIPSNodeURLConfig('/admin/getAttributeList', HttpMethod.GET),

    /**
     * AC9. 上级分类列表
     * @see(old) http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Class_AC9.md
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=83329062
     */
    CATEGORY_PARENT_LIST: resolveIPSNodeURLConfig('/admin/searchLevelClass', HttpMethod.GET),

    /**
     * AC8. 分类排序
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Class_AC8.md
     */
    UPDATE_CLASS_SORT: resolveIPSURLConfig('/admin/edit/sort'),

    /**
     * Q1. 根据参数获取期刊列表
     * @see（old） http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/qikan_Q1.md
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=38371356
     */
    ADMIN_QIKAN_LIST: resolveIPSNodeURLConfig('/admin/qikan/list'),

    /**
     * Q2. 期刊预览
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/qikan_Q2.md
     */

    PERIODICAL_PREVIEW: resolveIPSNodeURLConfig('/admin/qikan/display', HttpMethod.GET),

    /**
     * Q3. 期刊启用禁用
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/qikan_Q3.md
     */
    UPDATE_PERIODICAL_STATUS: resolveIPSURLConfig('/admin/qikan/state/change'),

    /**
     * Q4. 期刊评论列表
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/5628
     */
    PERIODICAL_COMMENT_LIST: resolveIPSNodeURLConfig('/admin/comment/list', HttpMethod.POST),

    /**
     * Q5. 评论显示设置
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/qikan_Q5.md
     */
    UPDATE_COMMENT_STATUS: resolveIPSURLConfig('/admin/comment/save/state'),
    /**
     * PQ17.期刊评论回复
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/5632
     */
    COMMENT_SAVE: resolveIPSNodeURLConfig('/admin/comment/save'),

    /**
     * A1. 活动列表
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A1.md
     */
    ACTIVITY_LIST: resolveIPSNodeURLConfig('/admin/act/list'),

    // 编辑活动信息
    ACTIVITY_PIC_INFO: resolveIPSNodeURLConfig('/admin/act/pic/info'),

    // 编辑活动保存
    ACTIVITY_PIC_SAVE: resolveIPSNodeURLConfig('/admin/act/pic/save'),


    /**
     * A2. 活动启用/禁用
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A2.md
     */
    UPDATE_ACTIVITY_STATUS: resolveIPSURLConfig('/admin/act/save/state'),

    /**
     * A30.批量设置是否对外展示
     * @see  http://yapi.tenyun.runsasoft.com/mock/68/admin/act/vendor/state/edit
     */
    ACT_VENDOR_STATE: resolveIPSNodeURLConfig('/admin/act/vendor/state/edit'),
    /**
     * A3. 报名列表标题
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=42172463
     */
    TITLE_LIST: resolveIPSNodeURLConfig('/admin/act/enter/title/list', HttpMethod.POST),

    /**
     * A5. 报名列表
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=42172467
     */
    REGISTERED_PERSON_LIST: resolveIPSNodeURLConfig('/admin/act/enter/list', HttpMethod.POST),

    /**
     * A5_1.报名抽取列表
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A5_1.md
     */
    REGISTERED_EXTRACTION_LIST: resolveIPSNodeURLConfig('/admin/act/extraction/list', HttpMethod.POST),

    /**
     * A5_3.获取抽取显示详情数据
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A5_3.md
     */
    REGISTERED_EXTRACTION_NUM: resolveIPSNodeURLConfig('/admin/act/extraction/num', HttpMethod.POST),

    /**
     * A5_2.发送抽中通知
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1492
     */
    POST_ACT_NOTICE: resolveIPSNodeURLConfig('/admin/act/notice', HttpMethod.POST),

    /**
     * A5_4.发送未抽中通知
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A5_4.md
     */
    POST_ACT_NOTICE_UNLOTTERY: resolveIPSNodeURLConfig('/admin/act/unLotteryNotice', HttpMethod.POST),

    /**
     * A5_5.获取该店铺其他活动列表
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=11404499
     */
    GET_OTHER_ACTIVITY_LIST: resolveIPSURLConfig('/admin/act/other/list', HttpMethod.GET),

    /**
     * A4. 活动预览
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A4.md
     */

    ACTIVITY_PREVIEW: resolveIPSNodeURLConfig('/admin/act/display', HttpMethod.GET),

    /**
     * A6.活动配置列列表
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A6.md
     */
    ACTIVITY_SET_COLUMN_LIST: resolveIPSURLConfig('/admin/act/column/config', HttpMethod.GET),

    /**
     * A7. 获取活动类型详情
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A7.md
     */
    GET_ACTIVITY_COLUMNS_INFO: resolveIPSNodeURLConfig('/admin/act/column/info', HttpMethod.POST),

    /**
     * A8.活动类型保存
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A8.md
     */
    UPDATE_ACTIVITY_COLUMNS_IFO: resolveIPSNodeURLConfig('/admin/act/column/save'),

    /**
     * AS8.删除云镜店下某个网点关联信息
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=12747484
     */
    DELETE_SITE_GROUP_INFO_NODE: resolveIPSNodeURLConfig('/admin/removeSiteGroupInfo'),
    /**
     * A8.删除云镜店下某个网点关联信息
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=12747484
     */
    DELETE_SITE_GROUP_INFO: resolveIPSURLConfig('/admin/removeSiteGroupInfo'),

    /**
     * A9.修改活动类型状态
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A9.md
     */
    UPDATE_ACTIVITY_TYPE_STATUS: resolveIPSURLConfig('/admin/act/edit/type/state'),

    /**
     * A10.活动类型列表
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A10.md
     */
    GET_ACTIVITY_TYPE_LIST: resolveIPSURLConfig('/admin/act/type/list', HttpMethod.GET),

    /**
     * A11.活动类型适用店铺详情
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A11.md
     */
    GET_ACTIVITY_TYPE_APPLY_SITES: resolveIPSURLConfig('/admin/act/type/site/list', HttpMethod.GET),

    /**
     * A12.活动类型适用店铺修改
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A12.md
     */
    UPDATE_ACTIVITY_TYPE_APPLY_SITES: resolveIPSURLConfig('/admin/act/type/site/save'),

    /**
     * AS27. 获取集团收益分享时效
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS27.md
     */
    GET_GROUP_SETTING: resolveIPSURLConfig('/admin/share/time/info', HttpMethod.GET),

    /**
     * AS28. 集团收益分享时效保存
     * @see http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/Admin_Site_AS28.md
     */
    UPDATE_GROUP_SET: resolveIPSURLConfig('/admin/share/time/save'),

    /**
     * AS29.获取集团的商户号列表
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=11404014
     */
    GROUP_MCH_ID_LIST: resolveIPSURLConfig('/admin/group/mchid/list', HttpMethod.GET),

    /**
     * AS30.获取网点组的商户号
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=11404020
     */
    GROUP_MCH_INFO: resolveIPSURLConfig('/admin/groupSite/mchid/info', HttpMethod.GET),

    /**
     *AS32.保存网点组的商户号
     * @see https://wiki.qingger.cn/pages/viewpage.action?pageId=11404042
     */
    SAVE_MCH_ID: resolveIPSNodeURLConfig('/admin/groupSite/mchId/choose', HttpMethod.POST),

    /**
     * A13.获取外部活动列表
     * http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A13.md
     */
    GET_CRM_ACT_LIST: resolveIPSURLConfig('/admin/crm/act/list', HttpMethod.GET),

    /**
     * A14.获取外部活动详情(查看列表中的网点组列表也用这个)
     * http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A14.md
     */
    GET_CRM_ACT_INFO: resolveIPSURLConfig('/admin/crm/act/info', HttpMethod.GET),

    /**
     * A15.外部活动保存
     * http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A15.md
     */

    GET_CRM_ACT_SAVE: resolveIPSURLConfig('/admin/crm/act/save', HttpMethod.POST),

    /**
     * A16.查看活动的二维码
     * http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A16.md
     */
    GET_CRM_ACT_QRCODE: resolveIPSNodeURLConfig('/admin/crm/act/qrCode', HttpMethod.POST),

    /**
     * A17.从crm更新活动数据
     * http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A17.md
     */
    UPDATE_CRM_ACT: resolveIPSURLConfig('/admin/crm/act/update', HttpMethod.POST),

    /**
     * A18.修改活动状态
     * http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/activity_A18.md
     */
    UPDATE_CRM_ACT_STATE: resolveIPSURLConfig('/admin/crm/act/change', HttpMethod.POST),

    /**
     * A19.活动对应报名信息的筛选项(发送抽中通知用到)
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=42172469
     */
    ADMIN_ACT_ORDER_CHOOSE_LIST: resolveIPSNodeURLConfig('/admin/act/order/choose/list', HttpMethod.POST),

    /**
     * A20.获取某个报名活动的会员等级
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=55312402
     */
    ADMIN_ACT_CST_LEVEL_LIST: resolveIPSNodeURLConfig('/admin/act/cst/level/list', HttpMethod.POST),

    /**
     * A21.报名抽取
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=55312402
     */
    ADMIN_ACT_EXTRACTION_SAVE: resolveIPSNodeURLConfig('/admin/act/extraction/save', HttpMethod.POST),

    /**
     * T1.获取网点的试穿人数统计
     * http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/tryOn_T1.md
     */
    SITE_TRY_ON_NUM: resolveIPSURLConfig('/admin/tryOn/siteTryOnNum', HttpMethod.GET),

    /**
     * T2.获取网点的试穿人数详情统计
     * http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/tryOn_T2.md
     */
    SITE_TRY_ON_NUM_BY_TIME: resolveIPSURLConfig('/admin/tryOn/siteTryOnNumByTime', HttpMethod.GET),

    /**
     * T3.获取网点的试穿商品排名
     * http://git.project.qingger.com/qingger/shop/blob/master/S2_Projects/P16_IPShop/backendAPI/APIDOC/tryOn_T3.md
     */
    SITE_TRY_ON_TOP: resolveIPSURLConfig('/admin/tryOn/siteTryOnTop', HttpMethod.GET),

    /**
     * R1.报名审核列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405458
     */
    GUIDER_REQUEST_LIST: resolveIPSNodeURLConfig('/admin/v/guider/request/list', HttpMethod.POST),

    /**
     * R2.报名详情
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405462
     */
    GUIDER_REQUEST_INFO: resolveIPSNodeURLConfig('/admin/v/guider/request/info', HttpMethod.GET),

    /**
     * R3.虚拟店长审核
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405464
     */
    GUIDER_REQUEST_SAVE: resolveIPSNodeURLConfig('/admin/v/guider/request/save', HttpMethod.POST),

    /**
     * R4.虚拟店长移除黑名单
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405466
     */
    REQUEST_REMOVE_BLACKLIST: resolveIPSNodeURLConfig('/admin/v/guider/request/remove/blacklist', HttpMethod.POST),

    /**
     * R5.虚拟店长预定义拒绝/提现理由列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12748382
     */
    REJECT_CONTENT_LIST: resolveIPSNodeURLConfig('/admin/v/guider/request/rejectContentList', HttpMethod.GET),

    /**
     * R6.虚拟店长：报名申请列表导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12748672
     */
    GUIDER_REQUEST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/guider/request/export', HttpMethod.GET),

    /**
     * T4.获取集团顾客试穿和导购出样配置信息
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12747588
     */
    GET_GROUP_CONFIG: resolveIPSURLConfig('/admin/tryOn/getGroupConfig', HttpMethod.GET),

    /**
     * T5.保存集团顾客试穿和导购出样相关配置信息
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12747590
     */
    SAVE_GROUP_CONFIG: resolveIPSURLConfig('/admin/tryOn/saveGroupConfig'),

    /**
     * VGC1.获取虚拟店长策略列表信息
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12747702
     */
    GUIDER_CONFIG_LIST: resolveIPSNodeURLConfig('/admin/v/guider/config/list', HttpMethod.GET),

    /**
     * VGC2.删除虚拟店长策略信息
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12747740
     */
    GUIDER_CONFIG_DELETE: resolveIPSNodeURLConfig('/admin/v/guider/config/delete'),

    /**
     * VGC3.新增虚拟店长策略信息
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12747801
     */
    GUIDER_CONFIG_ADD: resolveIPSNodeURLConfig('/admin/v/guider/config/add'),

    /**
     * VGC4.编辑虚拟店长策略信息
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12747812
     */
    GUIDER_CONFIG_EDIT: resolveIPSNodeURLConfig('/admin/v/guider/config/edit'),

    /**
     * VGC5.获取虚拟店长策略详细信息
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12749187
     */
    GUIDER_CONFIG_INFO: resolveIPSNodeURLConfig('/admin/v/guider/config/info', HttpMethod.GET),

    /**
     * VG1.虚拟店长列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405468
     */
    GUIDER_LIST: resolveIPSNodeURLConfig('/admin/v/guider/list', HttpMethod.GET),

    /**
     * VG2.虚拟店长分销历史
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405473
     */
    GUIDER_PROFIT_IN_LIST: resolveIPSNodeURLConfig('/admin/v/guider/profit/in/list', HttpMethod.GET),

    /**
     * VG3.虚拟店长提现历史
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405485
     */
    GUIDER_PROFIT_OUT_LIST: resolveIPSNodeURLConfig('/admin/v/guider/profit/out/list', HttpMethod.GET),

    /**
     * VG4.提现列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405543
     */
    GUIDER_ALL_PROFIT_OUT_LIST: resolveIPSNodeURLConfig('/admin/v/guider/all/profit/out/list', HttpMethod.POST),

    /**
     * VG5.虚拟店长提现审核拒绝
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405557
     */
    GUIDER_ALL_PROFIT_OUT_REJECT: resolveIPSNodeURLConfig('/admin/v/guider/all/profit/out/reject'),

    /**
     * VG6.虚拟店长提现审核通过
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405554
     */
    GUIDER_ALL_PROFIT_OUT_PASSED: resolveIPSNodeURLConfig('/admin/v/guider/all/profit/out/passed'),

    /**
     * VG7.虚拟店长提现列表（所有虚拟店长）导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12749394
     */
    GUIDER_ALL_PROFIT_OUT_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/guider/all/profit/out/list/export', HttpMethod.POST),

    /**
     * VG8.虚拟店长打款
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=14778490
     */
    GUIDER_ALL_PROFIT_OUT_LIST_EXPORT_PAY: resolveIPSNodeURLConfig('/admin/v/guider/all/profit/out/pay'),

    /**
     * VG11.虚拟店长列表导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12749072
     */
    GUIDER_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/guider/list/export', HttpMethod.GET),

    /**
     * VG12.虚拟店长分销历史导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12749196
     */
    GUIDER_PROFIT_IN_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/guider/profit/in/list/export', HttpMethod.GET),

    /**
     * VG13.虚拟店长提现历史导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12749202
     */
    GUIDER_PROFIT_OUT_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/guider/profit/out/list/export', HttpMethod.GET),

    /**
     * VG14.虚拟店长报表(分销报表)
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=16024829
     */
    GUIDER_REPORT_LIST: resolveIPSNodeURLConfig('/admin/v/guider/report/list'),

    /** VG36.分销成交报表
     * http://yapi.tenyun.runsasoft.com/mock/68/admin/v/fx/success/report/list
     */

    SUCCESS_REPORT_LIST: resolveIPSNodeURLConfig('/admin/v/fx/success/report/list'),
    /** VG37.分销结算报表
     * http://yapi.tenyun.runsasoft.com/mock/68/admin/v/fx/profit/report/list
     */

    PROFIT_REPORT_LIST: resolveIPSNodeURLConfig('/admin/v/fx/profit/report/list'),

    /* VG38.分销结算报表导出
    http://yapi.tenyun.runsasoft.com/mock/68/admin/v/fx/profit/report/list/export
     */
    PROFIT_REPORT_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/fx/profit/report/list/export'),
    /* VG39.分销成交报表导出
    http://yapi.tenyun.runsasoft.com/mock/68/admin/v/fx/success/report/list/export
     */
    SUCCESS_REPORT_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/fx/success/report/list/export'),
    /**
     * VG15.虚拟店长押金管理列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=16024930
     */
    GUIDER_DEPOSIT_OUT_LIST: resolveIPSNodeURLConfig('/admin/v/guider/deposit/out/list'),

    /**
     * VG16.拒绝虚拟店长押金退回
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=16024951
     */
    GUIDER_DEPOSIT_REJECT: resolveIPSNodeURLConfig('/admin/v/guider/deposit/reject'),

    /**
     * VG17.虚拟店长提现审核通过
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=16024984
     */
    GUIDER_DEPOSIT_PASSED: resolveIPSNodeURLConfig('/admin/v/guider/deposit/passed'),

    /**
     * VG18.关闭虚拟店长
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=16025003
     */
    GUIDER_CLOSE: resolveIPSNodeURLConfig('/admin/v/guider/close'),

    /**
     * VG19.开启虚拟店长
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=16025005
     */
    GUIDER_OPEN: resolveIPSNodeURLConfig('/admin/v/guider/open'),

    /**
     * VG1.虚拟店长列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405468
     */
    REPORT_GUIDER_LIST: resolveIPSNodeURLConfig('/admin/v/report/guider/list'),
    /**
     * VG43.分销员成交明细
     * https://yapi.tenyun.runsasoft.com/project/68/interface/api/5453
     */
    REPORT_GUIDER_DETAIL_LIST: resolveIPSNodeURLConfig('/admin/v/report/guider/detail/list'),
    /**
     * V40.分销员账户余额是否可以调整
     * https://yapi.tenyun.runsasoft.com/project/68/interface/api/4785
     */
    GUIDER_CHANGE_BALANCE_CHECK: resolveIPSNodeURLConfig('/admin/v/guider/change/balance/check'),
    /**
     * V41.分销员账户余额的调整
     * https://yapi.tenyun.runsasoft.com/project/68/interface/api/4776
     */
    GUIDER_CHANGE_BALANCE: resolveIPSNodeURLConfig('/admin/v/guider/change/balance'),
    /**
     * VG42.账户余额调整记录列表
     * https://yapi.tenyun.runsasoft.com/project/68/interface/api/4794
     */
    GUIDER_CHANGE_BALANCE_LIST: resolveIPSNodeURLConfig('/admin/v/guider/change/balance/list'),

    /**
     * VG21.虚拟店长分销报表的分销历史
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=55312500
     */
    REPORT_PROFIT_LIST: resolveIPSNodeURLConfig('/admin/v/guider/report/profit/in/list'),

    /**
     * VG22.虚拟店长分销报表提现历史
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=55312511
     */
    REPORT_PROFIT_OUT_LIST: resolveIPSNodeURLConfig('/admin/v/guider/report/profit/out/list'),

    /**
     * VG23.虚拟店长分销报表列表导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=55476225
     */
    REPORT_DISTRIBUTE_BOARD_LIST: resolveIPSNodeURLConfig('/admin/v/guider/report/list/export', HttpMethod.POST),

    /**
     * VG24.虚拟店长分销报表的分销历史导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=55934989
     */
    ADMIN_GUIDER_PROFIT_IN_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/guider/report/profit/in/list/export'),

    /**
     * VG25.虚拟店长分销报表的提现历史导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=55934997
     */
    ADMIN_GUIDER_PROFIT_OUT_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/guider/report/profit/out/list/export'),

    /**
     * P1.分销商品列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405511
     */
    GUIDER_PRODUCT_COMMISSION_LIST: resolveIPSNodeURLConfig('/admin/v/guider/product/commission/list', HttpMethod.GET),

    /**
     * P2.分销商品佣金保存
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405535
     */
    GUIDER_PRODUCT_COMMISSION_SAVE: resolveIPSNodeURLConfig('/admin/v/guider/product/commission/save'),

    /**
     * P3.分销商品佣金删除
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=11405537
     */
    GUIDER_PRODUCT_COMMISSION_REMOVE: resolveIPSNodeURLConfig('/admin/v/guider/product/commission/remove'),

    /**
     * P4.分销商品导入
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=14778501
     */
    GUIDER_PRODUCT_COMMISSION_IMPORT: resolveIPSNodeURLConfig('/admin/v/guider/product/commission/import'),

    /**
     * P5.分销商品导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=12749468
     */
    GUIDER_PRODUCT_COMMISSION_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/guider/product/commission/export'),

    /**
     * AD1. 获取后台菜单列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=14778479
     */
    ADMIN_AUTH_MENU_LIST: resolveIPSNodeURLConfig('/admin/auth/menu/list'),

    /**
     * AQ3. 期刊店铺筛选数据
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=14778479
     */
    ADMIN_QIKAN_CHOOSE_SITE_LIST: resolveIPSNodeURLConfig('/admin/qikan/choose/site/list'),

    /**
     * SK1. 秒杀活动列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=19103800
     */
    ADMIN_SEC_KILL_LIST: resolveIPSNodeURLConfig('/admin/sec/kill/list'),

    /**
     * SK2. 秒杀活动修改状态
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=19103811
     */
    ADMIN_SEC_KILL_STATE_EDIT: resolveIPSNodeURLConfig('/admin/sec/kill/state/edit'),

    /**
     * SK3. 秒杀活动详情
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=19103816
     */
    ADMIN_SEC_KILL_INFO: resolveIPSNodeURLConfig('/admin/sec/kill/info'),
    /**
     * AP32.批量查询商品信息
     * https://yapi.tenyun.runsasoft.com/project/68/interface/api/5527
     */
    ADMIN_SEARCH_PRODUCT_LIST: resolveIPSNodeURLConfig('/admin/search/product/list'),

    /**
     * SK4. 新增秒杀活动
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=19103822
     */
    ADMIN_SEC_KILL_ADD: resolveIPSNodeURLConfig('/admin/sec/kill/add'),

    /**
     * SK5. 编辑秒杀活动
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=19103831
     */
    ADMIN_SEC_KILL_SAVE: resolveIPSNodeURLConfig('/admin/sec/kill/save'),

    /**
     * SK6. 根据商品货号搜索商品
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=19529734
     */
    ADMIN_PRODUCT_INFO: resolveIPSNodeURLConfig('/admin/product/info'),

    /**
     * SK7. 秒杀订单列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=19922983
     */
    ADMIN_SEC_KILL_ORDER_LIST: resolveIPSNodeURLConfig('/admin/sec/kill/order/list'),

    /**
     * SK7.1. 秒杀订单列表导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=80675012
     */
    ADMIN_SEC_KILL_ORDER_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/sec/kill/order/list/export'),

    /**
     * SK8. 根据网点获取秒杀活动列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=19922983
     */
    ADMIN_SEC_KILL_DELETE: resolveIPSNodeURLConfig('/admin/sec/kill/delete'),

    /**
     * SK9. 秒杀活动删除
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=24739858
     */
    ADMIN_SEC_KILL_ACT_LIST: resolveIPSNodeURLConfig('/admin/sec/kill/act/list'),

    /**
     * SK10. 查看秒杀活动的适用网点
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=28508232
     */
    ADMIN_SEC_KILL_SITE_LIST: resolveIPSNodeURLConfig('/admin/sec/kill/site/list'),

    /**
     * SK11. 秒杀活动规格明细
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=28508232
     */
    ADMIN_GOODS_SKID_LIST: resolveIPSNodeURLConfig('/admin/sec/kill/spec/list'),
    /**
     *SK12.网点销售量-网点统计
     *@see https://runsa.yuque.com/runsadev/ir5wcy/cb4xi8
     */
    ADMIN_SEC_KILL_SITE_ORDER_LIST: resolveIPSNodeURLConfig('/admin/sec/kill/site/order/list'),

    /**
     * AORD1. 后台订单列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=22249484
     */
    ADMIN_ORDER_LIST: resolveIPSNodeURLConfig('/admin/order/list'),

    ADMIN_ORDER_INVOICE: resolveIPSNodeURLConfig('/scrm/api/crm/rest/order/invoice/changeStatus'),

    /* AORD7.后台订单管理 线下开票标记
    https://yapi.tenyun.runsasoft.com/project/68/interface/api/3796
    */
    ADMIN_ORDER_OFFLINE_INVOICING_SIGN: resolveIPSNodeURLConfig('/order/offline/invoicing/sign'),

    /**
     * AORD2. 后台订单列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=22249484
     */
    ADMIN_ORDER_CANCEL: resolveIPSNodeURLConfig('/admin/order/cancel'),

    /**
     * AORD3. 后台订单发起退款操作
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=22249491
     */
    ADMIN_ORDER_RETURN: resolveIPSNodeURLConfig('/admin/order/return'),

    /**
     * AORD4. 后台订单发起退款操作
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=22249491
     */
    ADMIN_ORDER_DETAIL: resolveIPSNodeURLConfig('/admin/order/info'),

    ADMIN_ORDER_RETURN_SAVE: resolveIPSNodeURLConfig('/admin/order/return/save'),
    // AORD6.后台订单开启关闭售后
    ADMIN_ORDER_STATE_SWITCH: resolveIPSNodeURLConfig('/admin/order/after/switch'),
    /**
     * AS53.获取虚拟店长相关配置
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=32538651
     */
    GET_VGUIDER_BASE_CONFIG: resolveIPSNodeURLConfig('/admin/v/guider/base/config'),

    /**
     * AS52.更新虚拟店长相关配置
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=32538649
     */
    SET_VGUIDER_BASE_CONFIG_SAVE: resolveIPSNodeURLConfig('/admin/v/guider/base/config/save'),

    /**
     * AS50.基于某一大类存储尺码对照表数据
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=32079917
     */
    SET_ADMIN_CLASS_SIZE_SAVE: resolveIPSNodeURLConfig('/admin/class/size/save'),

    /**
     * AS51.基于某一大类存储尺码对照表数据
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=32079917
     */
    GET_ADMIN_CLASS_SIZE: resolveIPSNodeURLConfig('/admin/class/size/info/get'),


    /**
     * PQ1. 获取后台发布期刊列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=38371356
     */
    ADMIN_PUBLISH_QIKAN_LIST: resolveIPSNodeURLConfig('/admin/publish/qikan/list'),

    /**
     * PQ2. 发布期刊修改状态
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=38371368
     */
    ADMIN_PUBLISH_QIKAN_STATE: resolveIPSNodeURLConfig('/admin/publish/qikan/state/edit'),

    /**
     * PQ3. 发布/编辑期刊
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=38371373
     */
    ADMIN_PUBLISH_QIKAN_EDIT: resolveIPSNodeURLConfig('/admin/publish/qikan/edit'),

    /**
     * PQ4. 根据商品货号搜索商品
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=38371398
     */
    ADMIN_PRODUCT_QIKAN_INFO: resolveIPSNodeURLConfig('/admin/product/qikan/info'),

    /**
     * PQ5. 期刊详情
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=38731783
     */
    ADMIN_PUBLISH_QIKAN_INFO: resolveIPSNodeURLConfig('/admin/publish/qikan/info'),

    /**
     * PQ6.后台期刊发布按钮
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=40730713
     */
    ADMIN_PUBLISH_QIKAN_STATUS: resolveIPSNodeURLConfig('/admin/publish/qikan/status'),

    /**
     * PQ7.后台发布期刊选择
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=38731810
     */
    ADMIN_PUBLISH_QIKAN_TYPE_CHOOSE: resolveIPSNodeURLConfig('/admin/publish/qikan/type/choose'),

    /**
     * PQ8.获取后台期刊热门标签
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=42172449
     */
    ADMIN_PUBLISH_QIKAN_LABEL: resolveIPSNodeURLConfig('/admin/publish/qikan/popular/label'),

    /**
     * PQ9.后台 期刊预览
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=42172480
     */
    ADMIN_PUBLISH_QIKAN_DISPLAY: resolveIPSNodeURLConfig('/admin/publish/qikan/display'),

    /**
     * PQ10. 选择网点
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=46399500
     */
    ADMIN_PUBLISH_QIKAN_SITE_LIST: resolveIPSNodeURLConfig('/admin/publish/qikan/site/list'),

    /**
     * PQ12.网点期刊运营数据
     * https://runsa.yuque.com/runsadev/ir5wcy/svpm2s
     */
    ADMIN_QIKAN_SITE_OPERATION_INFO: resolveIPSNodeURLConfig('/admin/qikan/site/operation/info'),

    /**
     * PQ13.网点期刊运营数据(网点)
     * https://runsa.yuque.com/runsadev/ir5wcy/zdeh7t
     */
    ADMIN_PQIKAN_ALL_SITE_LIST: resolveIPSNodeURLConfig('/admin/qikan/all/site/list'),

    /**
     * PQ14.网点期刊运营数据(网点)
     * https://runsa.yuque.com/runsadev/ir5wcy/zdeh7t
     */
    ADMIN_PQIKAN_CREATE_QIKAN_URL: resolveIPSNodeURLConfig('/admin/create/qikan/url'),

    /**
     * A1.1.活动列表导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=59277441
     */
    ADMIN_ACTIVITY_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/act/list/export'),

    /**
     * VG9.虚拟店长线下结算
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=84869175
     */
    OFFLINE_SETTLEMENT: resolveIPSNodeURLConfig('/admin/v/guider/off/line/pay'),

    /**
     * VG26.二级明细
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=84606978
     */
    CHILD_DETAIL_LIST: resolveIPSNodeURLConfig('/admin/v/report/guider/child/list'),

    /**
     * VG27.虚拟店长分销报表的所有分销历史导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=84607020
     */
    EXPORT_PROFIT_LIST: resolveIPSNodeTimeURLConfig('/admin/v/guider/report/all/profit/in/list/export', HttpMethod.POST),

    /**
     * PTA1. 后台拼团活动列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=82739249
     */
    ASSEMBLE_ACT_LIST: resolveIPSNodeURLConfig('/admin/pt/product/list', HttpMethod.POST),
    /**
     * PTA1.1.拼团活动列表导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=82739322
     */
    ADMIN_PT_PRODUCT_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/pt/product/list/export', HttpMethod.POST),

    /**
     * PTA2. 拼团活动结果跟踪(大区)
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=82739265
     */
    ASSEMBLE_ACT_RESULT: resolveIPSNodeURLConfig('/admin/pt/act/site/list', HttpMethod.POST),
    /**
     * PTA2.1.拼团活动跟踪结果(大区)导出
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=82739325
     */
    ADMIN_PT_ACT_SITE_EXPORT: resolveIPSNodeTimeURLConfig('/admin/pt/act/site/list/export', HttpMethod.POST),

    /**
     * PTA3. 拼团活动结果跟踪(网点)
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=82739270
     */
    ASSEMBLE_ACT_SITE_ORDER_LIST: resolveIPSNodeURLConfig('/admin/pt/act/all/site/list', HttpMethod.POST),

    /**
     * PTA4. 新增/编辑拼团活动
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=82739293
     */
    EDIT_ASSEMBLE_ACT: resolveIPSNodeURLConfig('/admin/pt/act/save', HttpMethod.POST),
    /**
     * PTA4. 获取拼团活动
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=82739293
     */
    GET_ASSEMBLE_ACT: resolveIPSNodeURLConfig('/admin/pt/act/info', HttpMethod.POST),
    /**
     *PTA5. 删除拼团活动
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=82739319
     */
    DELETE_ASSEMBLE_ACT: resolveIPSNodeURLConfig('/admin/pt/act/delete', HttpMethod.POST),
    /**
     * PTA6. 更新活动状态
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=85950488
     */
    UPDATE_ASSEMBLE_ACT_STATE: resolveIPSNodeURLConfig('/admin/pt/act/update/state', HttpMethod.POST),
    /**
     * PTA7. 查看拼团活动的适用网点
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89554946
     */
    PT_ACT_SITE_CHOOSE_LIST: resolveIPSNodeURLConfig('/admin/pt/act/site/choose/list', HttpMethod.POST),

    /* 所有文件导出 */
    ADMIN_EXPORT: resolveIPSNodeURLConfig('/admin/export', HttpMethod.POST),

    /**
     * 网点树接口
     */
    ADMIN_GET_AUTH_TREE_SITE: resolveIPSNodeURLConfig('/willDelete/admin/get/auth/tree/site', HttpMethod.POST),

    /**
     * PTA8.生成拼团活动预览二维码
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=91226190
     */
    PT_ACT_PREVIEW_CODE_GET: resolveIPSNodeURLConfig('/admin/pt/act/to/preview', HttpMethod.POST),

    /**
     * ALV1. 获取微信直播列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=88965221
     */
    WX_LIVE_VIEW_LIST: resolveIPSNodeURLConfig('/admin/wx/live/view/list'),

    /**
     * ALV2. 后台直播列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=88965173
     */
    LIVE_VIEW_LIST: resolveIPSNodeURLConfig('/admin/live/view/list'),

    /**
     * ALV3. 直播销售店铺列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=88965198
     */
    LIVE_VIEW_SITE_LIST: resolveIPSNodeURLConfig('/admin/live/view/site/list'),

    /**
     * ALV4. 直播店铺销售列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=88965201
     */
    LIVE_VIEW_SALE_LIST: resolveIPSNodeURLConfig('/admin/live/view/sale/list'),

    /**
     * ALV5. 修改直播状态
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=88965206
     */
    LIVE_VIEW_STATE_SAVE: resolveIPSNodeURLConfig('/admin/live/view/state/save'),

    /**
     * ALV6. 直播基础数据详情
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89555031
     */
    LIVE_VIEW_BASE_INFO: resolveIPSNodeURLConfig('/admin/live/view/base/info'),

    /**
     * ALV7. 直播基础数据保存
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89555037
     */
    LIVE_VIEW_BASE_SAVE: resolveIPSNodeURLConfig('/admin/live/view/base/save'),

    /**
     * ALV8. 同步微信直播商品
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89555059
     */
    LIVE_VIEW_PRODUCTS_UPDATE: resolveIPSNodeURLConfig('/admin/live/view/products/update'),

    /**
     * ALV9. 修改直播商品信息
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89555063
     */
    LIVE_VIEW_PRODUCTS_EDIT: resolveIPSNodeURLConfig('/admin/live/view/products/edit'),

    /**
     * ALV10. 直播宣传文案新增
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89555070
     */
    LIVE_VIEW_IMAGE_ADD: resolveIPSNodeURLConfig('/admin/live/view/images/add'),

    /**
     * ALV11. 直播预览落地页
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89555075
     */
    LIVE_VIEW_DISPLAY: resolveIPSNodeURLConfig('/admin/live/view/display'),

    /**
     * ALV12. 直播宣传文案删除
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89555102
     */
    LIVE_VIEW_IMAGE_DEL: resolveIPSNodeURLConfig('/admin/live/view/images/del'),

    /**
     * ALV13. 直播宣传文案排序
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89555104
     */
    LIVE_VIEW_IMAGE_SORT: resolveIPSNodeURLConfig('/admin/live/view/images/sort'),

    /**
     * ALV14. 直播落地页详情
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89555106
     */
    LIVE_VIEW_INFO: resolveIPSNodeURLConfig('/admin/live/view/info'),

    /**
     * ALV15. 直播落地页发布
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89555117
     */
    LIVE_VIEW_PUSH: resolveIPSNodeURLConfig('/admin/live/view/push'),

    /**
     * ALV16. 直播商品链接生成接口
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=89817090
     */
    LIVE_VIEW_PRODUCT_URL: resolveIPSNodeURLConfig('/admin/live/view/product/url'),
    /**
     * ALV17. 同步直播间信息
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=93290501
     */
    LIVE_VIEW_UPDATE_ROOM_WX: resolveIPSNodeURLConfig('/admin/live/view/update/room/wx'),
    /**
     * ALV20. 获取直播间商品列表
     * https://yapi.tenyun.runsasoft.com/project/68/interface/api/5842
     */
    LIVE_VIEW_PRODUCT_LIST: resolveIPSNodeURLConfig('/admin/live/view/product/list'),
    /**
     * ALV21. 下载商品讲解视频
     * https://yapi.tenyun.runsasoft.com/project/68/interface/api/5851
     */
    LIVE_DOWNLOAD_PRODUCT_VIEW: resolveIPSNodeURLConfig('/admin/downLoad/product/view'),

    /**
     * VG8.2 虚拟店长打款
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=94699552
     */
    GUIDER_BATCH_PAYMENT: resolveIPSNodeURLConfig('/admin/v/guider/all/profit/out/pay/batch'),

    /**
     * ZXA1. 主题颜色保存
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632850
     */
    DECORATION_THEME_COLOR_SAVE: resolveIPSNodeURLConfig('/admin/decoration/theme/color/save'),
    /**
     * ZXA1.1 主题颜色详情
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632850
     */
    DECORATION_THEME_COLOR_INFO: resolveIPSNodeURLConfig('/admin/decoration/theme/color/info'),

    /**
     * ZXA2.装修的菜单导航保存
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632850
     */
    DECORATION_THEME_NAV_SAVE: resolveIPSNodeURLConfig('/admin/decoration/menu/nav/save'),
    /**
     * ZXA3.2. hot页配置
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632850
     */
    DECORATION_THEME_HOT_SAVE: resolveIPSNodeURLConfig('/admin/decoration/hot/save'),

    /**
     * ZXA6.2 Hot页配置详情
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=97878056
     */
    DECORATION_THEME_HOT_INFO: resolveIPSNodeURLConfig('/admin/decoration/hot/info'),

    /**
     * ZXA4.菜单配置详情
     *https://wiki.qingger.cn/pages/viewpage.action?pageId=96632884
     */
    DECORATION_THEME_NAV_INFO: resolveIPSNodeURLConfig('/admin/decoration/menu/nav/info'),

    /**
     * ZXA6. 商城页配置详情
     *https://wiki.qingger.cn/pages/viewpage.action?pageId=96632947
     */
    DECORATION_MALL_INFO: resolveIPSNodeURLConfig('/admin/decoration/mall/info'),

    /**
     * ZXA6. 商城页配置详情
     *https://wiki.qingger.cn/pages/viewpage.action?pageId=96632947
     */
    DECORATION_MALL_SAVE: resolveIPSNodeURLConfig('/admin/decoration/mall/save'),
    /**
     * ZXA7.1独立店铺配置详情
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=98336860
     */
    DECORATION_SITE_CONFIG: resolveIPSNodeURLConfig('/admin/decoration/site/config/info'),

    /**
     * ZXA7.独立店铺配置
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=98336821
     */
    DECORATION_SITE_SAVE: resolveIPSNodeURLConfig('/admin/decoration/site/config/save'),
    /**
     * ZXA13.开屏广告装修配置保存
     * https://runsa.yuque.com/runsadev/ir5wcy/ivic13
     */
    ADMIN_OPEN_ADC_SAVE: resolveIPSNodeURLConfig('/admin/open/adv/save'),
    /**
     * ZXA13.开屏广告装修配置保存
     * https://runsa.yuque.com/runsadev/ir5wcy/ivic13
     */
    ADMIN_OPEN_ADC_INFO: resolveIPSNodeURLConfig('/admin/open/adv/info'),
    /**
     * SZX29.开屏广告列表
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/8620
     */
    ADMIN_OPEN_ADV_LIST: resolveIPSNodeURLConfig('/admin/y/site/open/adv/list'),
    /**
     * SZX30.开屏广告删除
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/8640
     */
    ADMIN_OPEN_ADV_DELETE: resolveIPSNodeURLConfig('/admin/y/site/open/adv/delete'),
    /**
     * AS107.保存相关网点组的配置信息
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/8636
     */
    ADMIN_SITE_GROUP_CONFIG_SAVE: resolveIPSNodeURLConfig('/admin/site/group/config/save'),

    /**
     * ZX-GS6.橱窗位的橱窗列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632963
     */
    CASE_LIST: resolveIPSNodeURLConfig('/admin/gs/case/list'),

    /**
     * ZX-GS7.新增/编辑橱窗
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632970
     */
    CASE_EDIT: resolveIPSNodeURLConfig('/admin/gs/case/edit', HttpMethod.POST),
    /**
     * ZX-GS18.获取已添加到橱窗位的店铺列表
     * https://yapi.tenyun.runsasoft.com/project/68/interface/api/6832
     */
    CASE_SITE_CODES: resolveIPSNodeURLConfig('/admin/gs/case/siteCodes', HttpMethod.POST),

    /**
     * ZX-GS8.橱窗详情
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632978
     */
    CASE_INFO: resolveIPSNodeURLConfig('/admin/gs/case/info'),

    /**
     * ZX-GS9.删除橱窗
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632976
     */
    CASE_DELETE: resolveIPSNodeURLConfig('/admin/gs/case/delete'),

    /**
     * ZX-GS1.店铺展示管理左侧树菜单
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632887
     */
    GS_TREE_LIST: resolveIPSNodeURLConfig('/admin/gs/tree/list'),

    /**
     * ZX-GS2.广告位的广告列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632893
     */
    GS_PROPAGEATE_LIST: resolveIPSNodeURLConfig('/admin/gs/propagate/list'),
    /**
     * ZX-GS3.新增/编辑广告
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632901
     */
    GS_PROPAGEATE_EDIT: resolveIPSNodeURLConfig('/admin/gs/propagate/edit'),
    /**
     * ZX-GS4.广告详情
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632914
     */
    GS_PROPAGEATE_INFO: resolveIPSNodeURLConfig('/admin/gs/propagate/info'),

    /**
     * ZX-GS5.设置广告状态
     *https://wiki.qingger.cn/pages/viewpage.action?pageId=96632909
     */
    GS_PROPAGEATE_STATE_UPDATE: resolveIPSNodeURLConfig('/admin/gs/propagate/state/update'),
    /**
     * ALV18.直播商品导入
     *https://wiki.qingger.cn/pages/viewpage.action?pageId=102072371
     */
    LIVE_VIEW_PRODUCTS_IMPORT: resolveIPSNodeURLConfig('/admin/live/view/products/import'),

    /**
     * ZX-GS6.橱窗位的橱窗列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=96632963
     */
    GS_CASE_LIST: resolveIPSNodeURLConfig('/admin/gs/case/list'),

    /**
     * ZXA8独立店铺配置预览
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=100925479
     */
    SITE_CONFIG_PREVIEW: resolveIPSNodeURLConfig('/admin/decoration/site/config/preview'),

    /**
     * A22.获取店铺促销活动列表
     * https://wiki.qingger.cn/pages/viewpage.action?pageId=109314083
     */
    GET_PRO_ACT_LIST: resolveIPSNodeURLConfig('/admin/pro/act/list'),

    /**
     * CXA6.促销活动列表
     * https://runsa.yuque.com/runsadev/ir5wcy/kg8x0o
     */
    PROMOTION_ACTIVITY_LIST: resolveIPSNodeURLConfig('/admin/promotion/list'),

    /**
     * CXA7.促销活动修改状态/删除
     * https://runsa.yuque.com/runsadev/ir5wcy/tlylpg
     */
    DEL_PROMOTION: resolveIPSNodeURLConfig('/admin/promotion/state/edit'),

    /**
     * CXA2.促销活动详情
     * https://runsa.yuque.com/runsadev/ir5wcy/gor70z
     */
    PROMOTION_INFO: resolveIPSNodeURLConfig('/admin/promotion/info'),

    /**
     * CXA3.新增/编辑促销活动
     * https://runsa.yuque.com/runsadev/ir5wcy/kfcpz3
     */
    EDIT_PROMOTION: resolveIPSNodeURLConfig('/admin/promotion/edit'),

    /**
     * CXA1.获取o2o后台促销活动
     * https://runsa.yuque.com/runsadev/ir5wcy/ev5vr3
     */
    GET_OMS_PROMOTION_INFO: resolveIPSNodeURLConfig('/admin/oms/promotion/info'),

    /**
     * CXA4.促销活动装修详情
     * https://runsa.yuque.com/runsadev/ir5wcy/tgeby5
     */
    PROMOTION_EDIT_INFO: resolveIPSNodeURLConfig('/admin/promotion/rent/info'),

    /**
     * CXA5.促销活动装修保存
     * https://runsa.yuque.com/runsadev/ir5wcy/vvfcb0
     */
    SAVE_PROMOTION_EDIT_INFO: resolveIPSNodeURLConfig('/admin/promotion/rent/save'),

    /**
     * CXA8.后台促销预览
     * https://runsa.yuque.com/runsadev/ir5wcy/aq1bg8
     */
    PROMOTION_PREVIEW: resolveIPSNodeURLConfig('/admin/promotion/display'),

    /**
     * CXA7.促销活动修改状态/删除
     * https://runsa.yuque.com/runsadev/ir5wcy/tlylpg
     */
    PROMOTION_STATE_EDIT: resolveIPSNodeURLConfig('/admin/promotion/state/edit'),

    /**
     * PQ16.期刊列表的预览
     * https://runsa.yuque.com/runsadev/ir5wcy/dm8nyk
     */
    QIKAN_LIST_PREVIEW: resolveIPSNodeURLConfig('/admin/publish/qikan/list/display'),

    /**
     * VG28.修改身份标识
     * https://runsa.yuque.com/runsadev/ir5wcy/ttay4f
     */
    UPDATE_IDENTITY_TAG: resolveIPSNodeURLConfig('/admin/v/guider/update/tag'),

    /**
     * VG29.虚拟店长导出数据模板1
     * https://runsa.yuque.com/runsadev/ir5wcy/xuz48f
     */
    VGUIDER_TEMPLATE_ONE_OUT: resolveIPSNodeURLConfig('/admin/v/guider/template/list/one/out'),

    /**
     * VG30.虚拟店长导出数据模板2
     * https://runsa.yuque.com/runsadev/ir5wcy/xbc60p
     */
    VGUIDER_TEMPLATE_TWO_OUT: resolveIPSNodeURLConfig('/admin/v/guider/template/list/two/out'),

    /**
     * VG31.虚拟店长扣税金额导入
     * https://runsa.yuque.com/runsadev/ir5wcy/yybu9k
     */
    VGUIDER_TEMPLATE_IMPORT: resolveIPSNodeURLConfig('/admin/v/guider/template/list/import'),

    /**
     * TS1.获取运费策略列表
     * https://runsa.yuque.com/runsadev/ir5wcy/xahszc
     */
    GET_POSTAGE_LIST: resolveIPSNodeURLConfig('admin/transport/list'),

    /**
     * TS1.2运费策略详情
     * https://runsa.yuque.com/runsadev/ir5wcy/an5381
     */
    GET_POSTAGE_INFO: resolveIPSNodeURLConfig('/admin/transport/info'),

    /**
     * TS1.3.新增/编辑运费策略
     * https://runsa.yuque.com/runsadev/ir5wcy/fdf9wt
     */
    EDIT_POSTAGE: resolveIPSNodeURLConfig('/admin/transport/edit'),

    /**
     * TS2.获取区域表
     * https://runsa.yuque.com/runsadev/ir5wcy/sgzg2h
     */
    GET_PROVINCE_LIST: resolveIPSNodeURLConfig('/admin/province/list'),

    /**
     * TS3.删除/禁用运费策略配置
     * https://runsa.yuque.com/runsadev/ir5wcy/tofbpp
     */
    DELETE_POSTAGE: resolveIPSNodeURLConfig('/admin/transport/state/edit'),

    /**
     * ZXA11. 个人中心详情
     * https://runsa.yuque.com/runsadev/ir5wcy/py9h5c
     */
    GET_MEMBER_CENTER_INFO: resolveIPSNodeURLConfig('/admin/member/center/info'),

    /**
     * ZXA12. 个人中心保存
     * https://runsa.yuque.com/runsadev/ir5wcy/ulrw96
     */
    MEMBER_CENTER_SAVE: resolveIPSNodeURLConfig('/admin/member/center/save'),

    /**
     * ZXA10.后台网点库存可提可售预览
     * https://runsa.yuque.com/runsadev/ir5wcy/dizyzf
     */
    GET_STOCK_INFO: resolveIPSNodeURLConfig('/admin/decoration/site/stock/info'),

    /**
     * 获取定制费的信息配置
     * https://runsa.yuque.com/runsadev/ir5wcy/ep15970gnycgu3w5
     */
    GET_CUSTOMIZE_INFO: resolveIPSNodeURLConfig('/admin/decoration/site/customize/info'),

    /**
     * 保存定制费的信息
     * https://runsa.yuque.com/runsadev/ir5wcy/xvv7v6rl7uupziyi
     */
    CUSTOMIZE_INFO_SAVE: resolveIPSNodeURLConfig('/admin/decoration/site/customize/save'),

    /**
     * AS99.店铺功能配置设置详情
     * https://yapi.tenyun.runsasoft.com/project/68/interface/api/4384
     */
    GET_SITE_OTHER_CONFIG_INFO: resolveIPSNodeURLConfig('/admin/site/other/config/info'),

    /**
     * ZXA9.小程序后台网点库存可提可售配置
     * https://runsa.yuque.com/runsadev/ir5wcy/gc4fdb
     */
    SAVE_SITE_STOCK: resolveIPSNodeURLConfig('/admin/decoration/site/stock/save'),
    /**
     * AS98.店铺功能配置设置保存
     * https://yapi.tenyun.runsasoft.com/project/68/interface/api/4376
     */
    SAVE_SITE_OTHER_CONFIG: resolveIPSNodeURLConfig('/admin/site/other/config/save'),

    /**
     * PQ1.1后台期刊列表导出
     * https://runsa.yuque.com/runsadev/ir5wcy/yzi424
     */
    QIKAN_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/qikan/list/export'),

    /**
     * ZAX15.微页面列表
     * https://runsa.yuque.com/runsadev/ir5wcy/tfcz6d
     */
    MINI_PAGE_LIST: resolveIPSNodeURLConfig('/admin/micro/page/list'),

    /**
     * ZXA16.微页面配置保存
     * https://runsa.yuque.com/runsadev/ir5wcy/mrps6w
     */
    MINI_PAGE_SAVE: resolveIPSNodeURLConfig('/admin/micro/page/config/save'),

    /**
     * ZXA17.微页面配置详情
     * https://runsa.yuque.com/runsadev/ir5wcy/kq32xi
     */
    MINI_PAGE_INFO: resolveIPSNodeURLConfig('/admin/micro/page/config/info'),

    /**
     * ZXA18.删除微页面
     * https://runsa.yuque.com/runsadev/ir5wcy/apcl8i
     */
    MINI_PAGE_DEL: resolveIPSNodeURLConfig('/admin/micro/page/config/delete'),

    /**
     * ZXA19.启用/禁用微页面
     * https://runsa.yuque.com/runsadev/ir5wcy/wx6gpn
     */
    MINI_PAGE_UPDATE: resolveIPSNodeURLConfig('/admin/micro/page/sate/update'),

    /**
     * AS2.1.获取CRM账套信息
     * https://runsa.yuque.com/runsadev/ir5wcy/xhdame
     */
    CRM_ACCOUNT_LIST: resolveIPSNodeURLConfig('/admin/crm/account/list'),

    /**
     * ADN3.获取集团信息
     * https://runsa.yuque.com/runsadev/ir5wcy/109674540
     */
    GET_GROUP_INFO: resolveIPSNodeURLConfig('/get/group/info'),
    /**
     * ADN4.保存集团信息
     * https://yapi.tenyun.runsasoft.com/project/68/interface/api/5649
     */
    GROUP_SAVE: resolveIPSNodeURLConfig('/admin/group/save'),

    /**
     * ZXA20.微页面配置预览
     * https://runsa.yuque.com/runsadev/ir5wcy/wndph8
     */
    MINI_PAGE_PREVIEW: resolveIPSNodeURLConfig('/admin/micro/page/config/display'),

    /**
     * ZX-GS10.视频位的视频列表
     * https://runsa.yuque.com/runsadev/ir5wcy/ruh3e1
     */
    GS_VIDEO_LIST: resolveIPSNodeURLConfig('/admin/gs/video/list'),

    /**
     * ZX-GS11.新增/编辑视频
     * https://runsa.yuque.com/runsadev/ir5wcy/xad9ov
     */
    GS_VIDEO_EDIT: resolveIPSNodeURLConfig('/admin/gs/video/edit'),

    /**
     * ZX-GS12.视频详情
     * https://runsa.yuque.com/runsadev/ir5wcy/rviyp6
     */
    GS_VIDEO_INFO: resolveIPSNodeURLConfig('/admin/gs/video/info'),

    /**
     * ZX-GS13.操作视频上下架状态
     * https://runsa.yuque.com/runsadev/ir5wcy/wmnvdc
     */
    GS_VIDEO_STATE_UPDATE: resolveIPSNodeURLConfig('/admin/gs/video/state/update'),

    /**
     * ZX-GS14.删除视频
     * https://runsa.yuque.com/runsadev/ir5wcy/wytl3y
     */
    GS_VIDEO_DELETE: resolveIPSNodeURLConfig('/admin/gs/video/delete'),

    /**
     * ZXA21.微页面暂存
     * https://runsa.yuque.com/runsadev/ir5wcy/nesq8x
     */
    MINI_PAGE_TEMP_SAVE: resolveIPSNodeURLConfig('/admin/micro/page/config/temp/sav'),

    /**
     * AS71.云镜店预览
     * https://runsa.yuque.com/runsadev/ir5wcy/ke8fxn
     */
    IPS_PREVIEW: resolveIPSNodeURLConfig('/admin/sg/group/qrcode/export'),

    /**
     * AC7.1获取属性列表（最新）
     * /admin/getAttrTreeList
     */
    GET_ATTR_TREE_LIST: resolveIPSNodeURLConfig('/admin/getAttrTreeList'),

    /**
     * VG20.1虚拟店长统计列表导出
     * https://runsa.yuque.com/runsadev/ir5wcy/vu06b0
     */
    GUIDER_COUNT_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/report/guider/list/export'),

    /**
     * CXA9.促销活动同步中台活动时间
     * https://runsa.yuque.com/runsadev/ir5wcy/hrnc7b
     */
    SYNCHRO_OMS_TIME: resolveIPSNodeURLConfig('/admin/synchro/oms/time'),

    /**
     * AS74.分账配置模板下载
     * https://runsa.yuque.com/runsadev/ir5wcy/fx1d1w
     */
    SPLIT_MONEY_TEMPLATE_EXPORT: resolveIPSNodeTimeURLConfig('/admin/split/money/template/export'),

    /**
     * AS72.网点分账配置
     * https://runsa.yuque.com/runsadev/ir5wcy/oe1hgv
     */
    SPLIT_MONEY_CONFIG_SAVE: resolveIPSNodeURLConfig('/admin/split/money/config/save'),

    /**
     * AS73.网点分账配置详情
     * https://runsa.yuque.com/runsadev/ir5wcy/wdg0y3
     */
    SPLIT_MONEY_CONFIG_INFO: resolveIPSNodeURLConfig('/admin/split/money/config/info'),

    /**
     * ALV2.1.后台直播列表导出
     * https://runsa.yuque.com/runsadev/ir5wcy/os5px3
     */
    VIDEO_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/live/view/list/export'),

    /**
     * SK1.2.秒杀活动列表导出
     * https://runsa.yuque.com/runsadev/ir5wcy/nug1rc
     */
    SKILL_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/sec/kill/list/export'),

    /**
     * AS76.根据店铺ID获取网点组信息
     * https://runsa.yuque.com/runsadev/ir5wcy/vsdant
     */
    SITE_GROUP_CONFIG: resolveIPSNodeURLConfig('/admin/site/group/config'),

    /**
     * ZX-GS17.查询CRM优惠卷列表
     * https://runsa.yuque.com/runsadev/ir5wcy/dq8d8q
     */
    COUPON_LIST: resolveIPSNodeURLConfig('/admin/coupon/list'),

    /**
     * ZX-GS16商品详情页面配置详情
     * https://runsa.yuque.com/runsadev/ir5wcy/gps5gh
     */
    PRODUCT_INFO_CONFIG: resolveIPSNodeURLConfig('/admin/product/info/config'),

    /**
     * ZX-GS15.商品详情页面配置保存
     * /admin/product/info/config/save
     */
    PRODUCT_INFO_CONFIG_SAVE: resolveIPSNodeURLConfig('/admin/product/info/config/save'),

    /**
     * ZXA22.云镜店分享配置
     * https://runsa.yuque.com/runsadev/ir5wcy/hx285s
     */
    SHARE_CONFIG_SAVE: resolveIPSNodeURLConfig('/admin/decoration/share/config/save'),

    /**
     * ZXA23.分享图配置详情
     * https://runsa.yuque.com/runsadev/ir5wcy/om0yry
     */
    SHARE_CONFIG_INFO: resolveIPSNodeURLConfig('/admin/decoration/share/config/info'),

    /**
     * ZXA24.网点分享图配置
     * https://runsa.yuque.com/runsadev/ir5wcy/dxuz3w
     */
    SITE_SHARE_CONFIG_SAVE: resolveIPSNodeURLConfig('/admin/site/share/config/save'),

    /**
     * ZXA25.网点分享图配置详情
     * /admin/site/share/config/info
     */
    SITE_SHARE_CONFIG_INFO: resolveIPSNodeURLConfig('/admin/site/share/config/info'),

    /**
     * FX2.分销策略列表
     * @see https://runsa.yuque.com/runsadev/ir5wcy/ucn26e
     */
    NEW_DISTRIBUTION_LIST: resolveIPSNodeURLConfig('/admin/distribution/list'),

    /**
     * FX1.添加分销策略
     * @see https://runsa.yuque.com/runsadev/ir5wcy/xu51qm
     */
    NEW_DISTRIBUTION_SAVE: resolveIPSNodeURLConfig('/admin/distribution/save'),

    /**
     * FX6.启用/禁用分销策略
     * @see https://runsa.yuque.com/runsadev/ir5wcy/igls96
     */
    NEW_DISTRIBUTION_UPDATE_STATE: resolveIPSNodeURLConfig('/admin/distribution/update/state'),

    /**
     * FX7.删除分销策略
     * @see https://runsa.yuque.com/runsadev/ir5wcy/wztg7h
     */
    NEW_DISTRIBUTION_DEL: resolveIPSNodeURLConfig('/admin/distribution/delete'),

    /**
     * FX5.设置默认策略
     * @see https://runsa.yuque.com/runsadev/ir5wcy/kfhklv
     */
    NEW_DISTRIBUTION_SET_DEFAULT: resolveIPSNodeURLConfig('/admin/distribution/set/default'),

    /**
     * FX3.配置分销策略
     * @see https://runsa.yuque.com/runsadev/ir5wcy/mzh91l
     */
    NEW_DISTRIBUTION_INFO_EDIT: resolveIPSNodeURLConfig('/admin/distribution/info/edit'),

    /**
     * FX4.分销策略配置详情
     * @see https://runsa.yuque.com/runsadev/ir5wcy/fd24r2
     */
    NEW_DISTRIBUTION_DETAIL: resolveIPSNodeURLConfig('/admin/distribution/info'),

    /**
     * FX22.会员等级
     * @see http://yapi.tenyun.runsasoft.com/mock/68/admin/buyer/level
     */

    BUYER_LEVEL: resolveIPSNodeURLConfig('/admin/buyer/level'),
    /**
     * FX24.分销申请二维码
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/6470
     */

    DISTRIBUTION_QRCODE_EXPORT: resolveIPSNodeURLConfig('/admin/distribution/qrcode/export'),
    /**
     * FX8.特殊商品佣金配置列表
     * @see https://runsa.yuque.com/runsadev/ir5wcy/gdzp12
     */
    PRODUCT_COMMISSION_POLICY_LIST: resolveIPSNodeURLConfig('/admin/product/commission/policy/list'),

    /**
     * FX10.特殊商品佣金配置删除
     * @see https://runsa.yuque.com/runsadev/ir5wcy/hg32nd
     */
    PRODUCT_COMMISSION_DELETE: resolveIPSNodeURLConfig('/admin/product/commission/delete'),

    /**
     * FX9.特殊商品佣金比例保存
     * @see https://runsa.yuque.com/runsadev/ir5wcy/pe7slg
     */
    PRODUCT_COMMISSION_SAVE: resolveIPSNodeURLConfig('/admin/product/commission/save'),

    /**
     * FX11.特殊商品数据模板导出
     * @see https://runsa.yuque.com/runsadev/ir5wcy/rahr84
     */
    PRODUCT_COMMISSION_TEMPLATE_EXPORT: resolveIPSNodeTimeURLConfig('/admin/product/commission/template/export'),

    /**
     * FX12.特殊商品佣金配置导入
     * @see https://runsa.yuque.com/runsadev/ir5wcy/vao2ph
     */
    PRODUCT_COMMISSION_TEMPLATE_IMPORT: resolveIPSNodeURLConfig('/admin/product/commission/template/import'),

    /**
     * FX13.分销员管理列表
     * @see https://runsa.yuque.com/runsadev/ir5wcy/unq9n9
     */
    DISTRIBUTOR_LIST: resolveIPSNodeURLConfig('/admin/distributor/list'),

    /**
     * FX14.分销员详情
     * @see https://runsa.yuque.com/runsadev/ir5wcy/wi23hd
     */
    DISTRIBUTOR_INFO: resolveIPSNodeURLConfig('/admin/distributor/info'),

    /**
     * R7.角色标签下拉框数据
     * @see https://runsa.yuque.com/runsadev/ir5wcy/ly1m5t
     */
    GUIDER_TAG_LIST: resolveIPSNodeURLConfig('/admin/v/guider/tagName/list'),

    /**
     * AS77.获取云镜店入驻网点组信息(树结构)
     * @see https://runsa.yuque.com/runsadev/ir5wcy/bsvz3x
     */
    REAL_SITE_LIST: resolveIPSNodeURLConfig('/willDelete/admin/getSgGroupInfoWithOrg'),


    /**
     * FX17.分销员策略批量变更数据导出
     * @see https://runsa.yuque.com/runsadev/ir5wcy/gv2hah
     */
    DISTRIBUTOR_CHANGE_EXPORT: resolveIPSNodeTimeURLConfig('/admin/distributor/change/export'),

    /**
     * FX15.分销员变更履历
     * @see https://runsa.yuque.com/runsadev/ir5wcy/rfkdsg
     */
    ISTRIBUTOR_CHANGE_HISTORY: resolveIPSNodeURLConfig('/admin/distributor/change/history'),

    /**
     * FX16.修改分销员的分销策略
     * @see https://runsa.yuque.com/runsadev/ir5wcy/fwy8el
     */
    DISTRIBUTOR_CHANGE: resolveIPSNodeURLConfig('/admin/distributor/change'),

    /**
     * R8.修改分销员申请策略信息
     * @see https://runsa.yuque.com/runsadev/ir5wcy/medgmr
     */
    GUIDER_REQUEST_POLICY_CHANGE: resolveIPSNodeURLConfig('/admin/v/guider/request/policy/change'),

    /**
     * VG15.1押金管理列表导出
     * @see https://runsa.yuque.com/runsadev/ir5wcy/gtcs7a
     */
    GUIDER_DEPOSIT_OUT_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/guider/deposit/out/list/export'),

    /**
     * FX19.分销员注销
     * @see https://runsa.yuque.com/runsadev/ir5wcy/uklcmg
     */
    DISTRIBUTOR_LOG_OUT: resolveIPSNodeURLConfig('/admin/distributor/log/out'),

    /**
     * FX20.批量修改分销员状态
     * @see https://runsa.yuque.com/runsadev/ir5wcy/lucgda
     */
    DISTRIBUTOR_UPDATE_STATE: resolveIPSNodeURLConfig('/admin/distributor/update/state'),

    /**
     * ADN4.清除商品详情缓存
     * @see https://runsa.yuque.com/runsadev/ir5wcy/ing6ez
     */
    CLEAR_PRODUCTCODES_CACHE: resolveIPSNodeURLConfig('/admin/clear/productCodes/cache'),

    /**
     * A25.查询所有标签
     * @see https://runsa.yuque.com/runsadev/ir5wcy/lkozna
     */
    CUSTOMER_LABEL: resolveIPSNodeURLConfig('/admin/customer/label'),

    /**
     * A26.抽签活动试算
     * @see https://runsa.yuque.com/runsadev/ir5wcy/qgbpzl
     */
    ACT_EXTRACTION_TRIAL: resolveIPSNodeURLConfig('/admin/act/extraction/trial'),

    /**
     * A27.顾客信息上传
     * @see https://runsa.yuque.com/runsadev/ir5wcy/xhhm7g
     */
    CUSTOMER_CSTID_IMPORT: resolveIPSNodeURLConfig('/admin/customer/cstId/import'),

    /**
     * PQ2. 发布期刊修改状态
     * @see https://runsa.yuque.com/runsadev/ir5wcy/38371368
     */
    QIKAN_STATE_EDIT: resolveIPSNodeURLConfig('/admin/publish/qikan/state/edit'),

    /**
     * FX21.特殊商品全部删除
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/904
     */
    PRODUCT_COMMISSION_CLEAR: resolveIPSNodeURLConfig('/admin/product/commission/all/delete'),

    /**
     * AP-AP1.商品管理列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/494
     */
    SITE_PRODUCT_LIST: resolveIPSNodeURLConfig('/admin/product/manage/list'),

    /**
     * AP-AP2.编辑商品
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/500
     */
    SITE_PRODUCT_ADD: resolveIPSNodeURLConfig('/admin/product/add'),

    /**
     * AP-AP3.商品管理详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/858
     */
    SITE_PRODUCT_INFO: resolveIPSNodeURLConfig('/admin/product/manage/info'),

    /**
     * AP-AP4.同步库存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/534
     */
    SITE_PRODUCT_UPDATE_STOCK: resolveIPSNodeURLConfig('/admin/product/manage/update/stock'),

    /**
     * AP-AP5.商品批量修改状态
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/538
     */
    SITE_PRODUCT_UPDATE_STATE: resolveIPSNodeURLConfig('/admin/product/manage/update/state'),

    /**
     * SZX1.菜单导航配置详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/844
     */
    SITE_MENU_NAV_INFO: resolveIPSNodeURLConfig('/admin/y/site/menu/nav/info'),

    /**
     * SZX2.菜单导航配置保存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/846
     */
    SITE_MENU_NAV_SAVE: resolveIPSNodeURLConfig('/admin/y/site/menu/nav/save'),

    /**
     * SZX3.HOT页配置详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/848
     */
    SITE_HOT_INFO: resolveIPSNodeURLConfig('/admin/y/site/hot/info'),

    /**
     * SZX4.HOT页配置保存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/850
     */
    SITE_SAVE: resolveIPSNodeURLConfig('/admin/y/site/save'),

    /**
     * SZX5.商城页配置详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/854
     */
    SITE_MALL_INFO: resolveIPSNodeURLConfig('/admin/y/site/mall/info'),

    // /**
    //  * SZX6.商城页配置保存
    //  * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/856
    //  */
    // SITE_MALL_SAVE: resolveIPSNodeURLConfig("/admin/y/site/mall/save"),
    /**
     * SZX6.商城、个人中心页布局保存
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/3726
     */
    COMPONENT_LAYOUT_SAVE: resolveIPSNodeURLConfig('/admin/component/layout/save'),
    /**
     * SZX6.商城、个人中心页内容保存
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/3724
     */
    COMPONENT_CONTENT_SAVE: resolveIPSNodeURLConfig('/admin/component/content/save'),

    /**
     * SZX7.个人中心详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/860
     */
    SITE_MEMBER_CENTER_INFO: resolveIPSNodeURLConfig('/admin/y/site/member/center/info'),

    // /**
    //  * SZX8.个人中心保存
    //  * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/862
    //  */
    // SITE_MEMBER_CENTER_SAVE: resolveIPSNodeURLConfig("/admin/y/site/member/center/save"),
    /* 闪屏广告详情 */
    SITE_FLASH_ADV_INFO: resolveIPSNodeURLConfig('/admin/y/site/flash/info'),
    /**
     * SZX9.开屏广告配置详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/864
     */
    SITE_OPEN_ADV_INFO: resolveIPSNodeURLConfig('/admin/y/site/open/adv/info'),

    /**
     * SZX10.开屏广告配置保存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/866
     */
    SITE_OPEN_ADV_SAVE: resolveIPSNodeURLConfig('/admin/y/site/open/adv/save'),

    /**
     * SZX11.商品详情页配置详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/868
     */
    SITE_PRODUCT_INFO_CONFIG: resolveIPSNodeURLConfig('/admin/y/site/product/info/config'),

    /**
     * SZX12.商品详情页配置保存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/870
     */
    SITE_PRODUCT_SAVE_CONFIG: resolveIPSNodeURLConfig('/admin/y/site/product/save/config'),

    /**
     * SZX13.分享图配置详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/872
     */
    SITE_SHARE_INFO_CONFIG: resolveIPSNodeURLConfig('/admin/y/site/share/config/info'),

    /**
     * SZX14.分享图配置保存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/874
     */
    SITE_SHARE_SAVE_CONFIG: resolveIPSNodeURLConfig('/admin/y/site/share/config/save'),

    /**
     * SZX15.悬浮图标配置详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/876
     */
    SITE_HOVER_ICON_INFO: resolveIPSNodeURLConfig('/admin/y/site/hover/icon/info'),

    /**
     * SZX16.悬浮图标配置保存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/878
     */
    SITE_HOVER_ICON_SAVE: resolveIPSNodeURLConfig('/admin/y/site/hover/icon/save'),

    /**
     * AP-AP10.获取尺码对照表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/970
     */
    SITE_CLASS_PIC_INFO: resolveIPSNodeURLConfig('/admin/class/pic/info'),

    /**
     * AP-AP9.保存尺码对照表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/960
     */
    SITE_CLASS_PIC_SAVE: resolveIPSNodeURLConfig('/admin/class/pic/save'),

    /**
     * AP-AP8.编辑分类状态
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/940
     */
    SITE_PRODUCT_CLASS_EDIT_STATE: resolveIPSNodeURLConfig('/admin/product/class/editState'),

    /**
     * AP-AP7.新增/编辑分类
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/938
     */
    SITE_CLASS_EDIT: resolveIPSNodeURLConfig('/admin/y/class/edit'),

    /**
     * AP-AP6.店铺分类列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/934
     */
    SITE_CLASS_LIST: resolveIPSNodeURLConfig('/admin/y/class/list'),

    /**
     * AP-AP11.批量添加商品导入文件
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/982
     */
    SITE_ADD_PRODUCT_IMPORT: resolveIPSNodeURLConfig('/admin/add/product/import'),

    /**
     * AP-AP12.批量添加商品确认
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/986
     */
    SITE_ADD_PRODUCT_IMPORT_CONFIRM: resolveIPSNodeURLConfig('/admin/add/product/import/confirm'),
    /**
     * AP-AP26.批量导入上下架
     * @see http://yapi.tenyun.runsasoft.com/mock/68/admin/product/change/state
     */
    SITE_PRODUCT_CHANGE_STATE: resolveIPSNodeURLConfig('/admin/product/change/state'),

    /**
     * SZX17.微页面配置详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/932
     */
    SITE_MICRO_PAGE_CONFIG_INFO: resolveIPSNodeURLConfig('/admin/y/micro/page/config/info'),

    /**
     * SZX18.微页面配置保存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/936
     */
    SITE_MICRO_PAGE_CONFIG_SAVE: resolveIPSNodeURLConfig('/admin/y/micro/page/config/save'),

    /**
     * SZX19.云商城网点组微页面详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/958
     */
    SITE_MICRO_PAGE_INFO: resolveIPSNodeURLConfig('/admin/y/micro/page/config/info'),

    /**
     * SZX20.云商城网点组微页面保存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/962
     */
    SITE_MICRO_PAGE_SAVE: resolveIPSNodeURLConfig('/admin/y/micro/page/config/save'),

    /**
     * SZX19.微页面列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1032
     */
    SITE_MICRO_PAGE_LIST: resolveIPSNodeURLConfig('/admin/y/micro/page/list'),

    /**
     * SZX20.删除微页面
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1042
     */
    SITE_MICRO_PAGE_DELETE: resolveIPSNodeURLConfig('/admin/y/micro/page/config/delete'),

    /**
     * SZX21.启用/禁用微页面
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1044
     */
    SITE_MICRO_PAGE_UPDATE_STATE: resolveIPSNodeURLConfig('/admin/y/micro/page/sate/update'),

    /**
     * SZX22.微页面配置预览
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1048
     */
    SITE_MICRO_PAGE_CONFIG_DISPLAY: resolveIPSNodeURLConfig('/admin/y/micro/page/config/display'),

    /**
     * SZX23.微页面暂存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1050
     */
    SITE_MICRO_PAGE_TEMP_SAVE: resolveIPSNodeURLConfig('/admin/y/micro/page/config/temp/save'),

    /**
     * AP-AP2.编辑商品
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/500
     */
    SITE_PRODUCT_MANAGE_ADD: resolveIPSNodeURLConfig('/admin/product/manage/add'),
    /**
     * PIC.批量转图片地址
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/5411
     */
    PICS_CHANGE: resolveIPSNodeURLConfig('/pics/change'),
    /**
     * AP31.更新商品sku信息
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/5423
     */

    UPDATE_PRODUCT_SKUS: resolveIPSNodeURLConfig('/admin/update/product/skus'),

    /**
     * AP-AP4.同步数据
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/534
     */
    SITE_PRODUCT_STOCK_UPDATE: resolveIPSNodeURLConfig('/admin/product/manage/update/stock'),

    /**
     * AP-AP14.批量设置分类
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1134
     */
    SITE_PRODUCT_UPDATE_CLASS: resolveIPSNodeURLConfig('/admin/product/manage/update/class'),

    /**
     * AP-AP13.删除分类
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1070
     */
    SITE_PRODUCT_CLASS_DELETE: resolveIPSNodeURLConfig('/admin/product/class/delete'),

    /**
     * AS78.获取参与分销网点列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1010
     */
    ClOUD_DISTRIBUTION_SITE_LIST: resolveIPSNodeURLConfig('/admin/cloud/distribution/site/list'),

    /**
     * AS79.设置参与分销网点
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1012
     */
    ClOUD_DISTRIBUTION_SITE_ADD: resolveIPSNodeURLConfig('/admin/cloud/distribution/site/add'),

    /**
     * SZX24.HOT页配置预览
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1148
     */
    SITE_HOT_CONFIG_DISPLAY: resolveIPSNodeURLConfig('/admin/y/site/hot/config/display'),

    /**
     * SZX25.商城页配置预览
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1150
     */
    SITE_MALL_CONFIG_DISPLAY: resolveIPSNodeURLConfig('/admin/y/site/mall/config/display'),

    /**
     * SZX26.个人中心配置预览
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1152
     */
    SITE_MEMBER_CONFIG_DISPLAY: resolveIPSNodeURLConfig('/admin/y/site/member/config/display'),

    /**
     * AS80.获取某虚拟网点的分销网点
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1014
     */
    CLOUD_DISTRIBUTION_SITE_GET: resolveIPSNodeURLConfig('/admin/cloud/distribution/site/get'),

    /**
     * AP-AP15.获取分类下的商品信息
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1206
     */
    SITE_CLASS_PRODUCT_LIST: resolveIPSNodeURLConfig('/admin/get/class/product/list'),

    /**
     * AS81.保存尺码对照表(新)
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1232
     */
    CLASS_SIZE_SAVE_NEW: resolveIPSNodeURLConfig('/admin/class/size/save/new'),

    /**
     * AS82.获取尺码对照表(新)
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1238
     */
    CLASS_SIZE_GET_NEW: resolveIPSNodeURLConfig('/admin/class/size/get/new'),

    /**
     * SZX14.分享图配置保存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1252
     */
    Y_SITE_SHARE_CONFIG_SAVE: resolveIPSNodeURLConfig('/admin/y/site/share/config/save'),

    /**
     * SZX13.分享图配置详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1250
     */
    Y_SITE_SHARE_CONFIG_INFO: resolveIPSNodeURLConfig('/admin/y/site/share/config/info'),

    /**
     * 获取商品属性筛选列表
     */
    PRODUCT_ATTR_LIST: resolveIPSNodeURLConfig('/admin/new/getAttributeList', HttpMethod.GET),

    /* 根据商品货号更新商品价格 */

    PRODUCT_CHANGE_PRICE: resolveIPSNodeURLConfig('admin/product/change/price'),

    /* AP-AP25. 根据商品货号更新商品价格验证 */
    PRODUCT_CHANGE_CHECK: resolveIPSNodeURLConfig('/admin/product/change/check'),
    /**
     * AS84.筛选项配置列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1262
     */
    CLASS_FILTER_LIST: resolveIPSNodeURLConfig('/admin/class/filter/list'),

    /**
     * AS83.筛选项配置保存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1260
     */
    CLASS_FILTER_SAVE: resolveIPSNodeURLConfig('/admin/class/filter/save'),

    /**
     * AS85.新增下级
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1266
     */
    CLASS_FILTER_SECOND_SAVE: resolveIPSNodeURLConfig('/admin/class/filter/second/save'),

    /**
     * AS86.筛选项状态修改
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1268
     */
    CLASS_FILTER_STATE_CHANGE: resolveIPSNodeURLConfig('/admin/class/filter/state/change'),

    /**
     * AS87.筛选项分类删除
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1270
     */
    CLASS_FILTER_DELETE: resolveIPSNodeURLConfig('/admin/class/filter/delete'),

    /**
     * AS88.筛选项配置详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1272
     */
    CLASS_FILTER_INFO: resolveIPSNodeURLConfig('/admin/class/filter/info'),

    /**
     * A28.获取互动活动列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1454
     */
    // INTER_ACTIVE_LIST: resolveIPSNodeURLConfig("/admin/inter/act/list"),
    INTER_ACTIVE_LIST: resolveIPSNodeURLConfig('/scrm/api/crm/iactivity/common/getActivityByRmall'),

    /**
     * AP-AP16.店铺分类列表(新)
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1478
     */
    SITE_CLASS_LIST_NEW: resolveIPSNodeURLConfig('/admin/y/class/list/new'),

    /**
     * AP-AP17.新增/编辑分类(新)
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1482
     */
    SITE_CLASS_EDIT_NEW: resolveIPSNodeURLConfig('/admin/y/class/edit/new'),

    /**
     * AP-AP18.编辑分类状态(新)
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1484
     */
    PRODUCT_CLASS_EDITSTATE_NEW: resolveIPSNodeURLConfig('/admin/product/class/editState/new'),

    /**
     * AP-AP19.删除分类(新)
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1486
     */
    PRODUCT_CLASS_DELETE_NEW: resolveIPSNodeURLConfig('/admin/product/class/delete/new'),

    /**
     * AP-AP20.绑定主档分类
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1488
     */
    PROUCT_RELATE_ATTRIBUTE: resolveIPSNodeURLConfig('/admin/product/relate/attribute'),
    /**
     * AP-AP27.编辑一级分类
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1488
     */
    FIRST_CLASS_EDIT: resolveIPSNodeURLConfig('/admin/y/first/class/edit'),

    /**
     * VG32.二级列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1520
     */
    GUIDER_SECOND_LIST: resolveIPSNodeURLConfig('/admin/v/guider/second/list'),

    /**
     * VG33.解除一二级关系
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1522
     */
    GUIDER_SECOND_REMOVE: resolveIPSNodeURLConfig('/admin/v/guider/second/remove'),

    /**
     * VG34.二级明细列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1524
     */
    REPORT_GUIDER_CHILD_LIST: resolveIPSNodeURLConfig('/admin/v/report/guider/child/list/new'),

    /**
     * CP1.优惠券列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1540
     */
    SITE_COUPON_LIST: resolveIPSNodeURLConfig('/admin/site/coupon/list'),

    /**
     * CP2.添加券
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1542
     */
    SITE_COUPON_ADD: resolveIPSNodeURLConfig('/admin/site/coupon/add'),

    /**
     * 获取筛选条件详情接口(访问crm接口)
     */
    CUSTOME_CONDITION: resolveIPSCRMURLConfig('/api/cst-filter/predicate/find', HttpMethod.GET),

    /**
     * CP7.CRM优惠券详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1552
     */
    CRM_COUPON_INFO: resolveIPSNodeURLConfig('/admin/crm/coupon/info'),

    /**
     * CP3.优惠券详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1544
     */
    SITE_COUPON_INFO: resolveIPSNodeURLConfig('/admin/site/coupon/info'),

    /**
     * CP4.删除优惠券
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1546
     */
    SITE_COUPON_DELETE: resolveIPSNodeURLConfig('/admin/site/coupon/delete'),

    /**
     * CP5.批量上下架
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1548
     */
    SITE_COUPON_UPDATE_STATE: resolveIPSNodeURLConfig('/admin/site/coupon/update/state'),
    /**
     * AP28.商品管理列表导出
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/3460
     * */
    PRODUCT_LIST_EXPORT: resolveIPSNodeURLConfig('/admin/product/manage/list/export'),
    /**
     * CP6.关联商品列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1550
     */
    SITE_COUPON_PRODUCT_LIST: resolveIPSNodeURLConfig('/admin/site/coupon/product/list'),

    /**
     * CP9.刷新关联商品
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1558
     */
    SITE_COUPON_UPDATE_PRODUCT: resolveIPSNodeURLConfig('/admin/site/coupon/update/product'),

    /**
     * AP-AP21.可领券列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1562
     */
    SITE_PRODUCT_COUPON_LIST: resolveIPSNodeURLConfig('/admin/y/coupon/list'),

    /**
     * CP8.关联商品列表导出
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1556
     */
    SITE_COUPON_PRODUCT_EXPORT: resolveIPSNodeTimeURLConfig('/admin/site/coupon/product/list/export'),

    /**
     * CP10.批量刷新上架券关联商品
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1566
     */
    SITE_COUPON_OPEN_UPDATE: resolveIPSNodeURLConfig('/admin/site/coupon/open/update'),

    /**
     * AS92.自定义尺码对照表详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1574
     */
    SIZE_MAPPING_INFO: resolveIPSNodeURLConfig('/admin/size/mapping/info'),

    /**
     * AS90.保存自定义尺码对照表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1570
     */
    SIZE_MAPPING_SAVE: resolveIPSNodeURLConfig('/admin/size/mapping/save'),

    /**
     * AS91.上传尺码对照表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1572
     */
    SIZE_MAPPING_UPLOAD: resolveIPSNodeURLConfig('/admin/size/post'),

    /**
     * AS93.尺码对照清楚全部
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1576
     */
    SIZE_MAPPING_CLEAR_ALL: resolveIPSNodeURLConfig('/admin/size/clear/all'),

    /**
     * AS95.删除当前尺码对照表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1602
     */
    SIZE_MAPPING_DELETE: resolveIPSNodeURLConfig('/admin/size/delete'),

    /**
     * TAG1.商品角标列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1664
     */
    TAG_MAPPING_LIST: resolveIPSNodeURLConfig('/admin/y/tag/list'),

    /**
     * TAG5.角标保存
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1698
     */
    TAG_MAPPING_SAVE: resolveIPSNodeURLConfig('/admin/y/tag/save'),

    /**
     * TAG3.角标批量修改状态
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1680
     */
    TAG_MAPPING_UPDATE_STATE: resolveIPSNodeURLConfig('/admin/y/tag/update/state'),

    /**
     * TAG4.角标详情
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1690
     */
    TAG_MAPPING_INFO: resolveIPSNodeURLConfig('/admin/y/tag/info'),

    /**
     * AP-AP22.商品角标列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1706
     */
    PRODUC_MAPPING_TAGLIST: resolveIPSNodeURLConfig('/admin/y/product/tag/list'),

    /**
     * AP-AP23.商品角标删除
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1714
     */
    PRODUC_MAPPING_TAGDELETE: resolveIPSNodeURLConfig('/admin/y/product/tag/delete'),

    /**
     * SKG1.秒杀组活动列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1746
     */
    ADMIN_SEC_KILL_GROUP_LIST: resolveIPSNodeURLConfig('/admin/sec/kill/group/list'),

    /**
     * SKG2.秒杀组适用网点列表
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/1754
     */
    ADMIN_SEC_KILL_GROUP_SITE_LIST: resolveIPSNodeURLConfig('/admin/sec/kill/group/site/list'),

    /**
     * SKG3.秒杀组销售量列表
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1746
     */
    ADMIN_SEC_KILL_GROUP_ORDER_LIST: resolveIPSNodeURLConfig('/admin/sec/kill/group/sale/list'),

    /**
     * SKG4.秒杀组状态修改
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/1770
     */
    ADMIN_SEC_KILL_GROUP_STATE_EDIT: resolveIPSNodeURLConfig('/admin/sec/kill/group/edit/state'),

    /**
     * SKG5.秒杀组详情
     * http://yapi.tenyun.runsasoft.com/mock/68/admin/sec/kill/group/info
     */
    ADMIN_SEC_KILL_GROUP_INFO: resolveIPSNodeURLConfig('/admin/sec/kill/group/info'),

    /**
     * SKG6.秒杀组保存
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/1786
     */
    ADMIN_SEC_KILL_GROUP_SAVE: resolveIPSNodeURLConfig('/admin/sec/kill/group/save'),

    /**
     * SKG7.修改秒杀组商品信息(价格/库存)
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/1804
     */
    ADMIN_SEC_KILL_GROUP_PRODUCT_EDIT: resolveIPSNodeURLConfig('/admin/sec/kill/group/product/edit'),

    /**
     * SKG8.删除秒杀组商品信息(下架)
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/1812
     */
    ADMIN_SEC_KILL_GROUP_PRODUCT_DEL: resolveIPSNodeURLConfig('/admin/sec/kill/group/product/delete'),

    /**
     * SKG11.删除秒杀组
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/1996
     */
    ADMIN_SEC_KILL_GROUP_DEL: resolveIPSNodeURLConfig('/admin/sec/kill/group/delete'),

    /**
     * TAG2.角标关联商品列表
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/1672
     */
    ADMIN_TAG_PRODUCT_LIST: resolveIPSNodeURLConfig('/admin/y/tag/product/list'),
    /**
     * SKG7-1.批量修改秒杀组商品信息(价格/库存)
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/2014
     */
    ADMIN_SEC_KILL_GROUP_PRODUCTS_EDIT: resolveIPSNodeURLConfig('/admin/sec/kill/group/products/edit'),

    /**
     * SK13.生成秒杀/秒杀组链接
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/2032
     */
    ADMIN_CREATE_SK_URL: resolveIPSNodeURLConfig('/admin/create/sk/url'),

    /* PTA9. 生成拼团链接
    http://yapi.tenyun.runsasoft.com/mock/68/admin/create/pt/url
    */
    ADMIN_CREATE_PT_URL: resolveIPSNodeURLConfig('/admin/create/pt/url'),

    /*  ALV19. 生成直播链接
    http://yapi.tenyun.runsasoft.com/mock/68/admin/create/live/url
    */
    ADMIN_CREATE_LIVE_URL: resolveIPSNodeURLConfig('/admin/create/live/url'),
    /**
     * VG35.二级列表下载
     * http://yapi.tenyun.runsasoft.com/project/68/interface/api/2052
     */
    ADMIN_V_GUIDER_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/v/guider/second/list/export'),

    /**
     * FX22.分销员管理列表下载
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/2042
     */
    DISTRIBUTOR_LIST_EXPORT: resolveIPSNodeTimeURLConfig('/admin/distributor/list/export'),

    /**
     * R9.获取七牛返回保存excel的url
     * @see http://yapi.tenyun.runsasoft.com/project/68/interface/api/2446
     */
    GET_EXCEL_DOWNLOAD_URL: resolveIPSNodeURLConfig('/admin/get/qiniu/excel/url'),

    /**
     * AREA0..区域排除店铺接口
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/3604
     */
    AREA_OUT_SITE_LIST: resolveIPSNodeURLConfig('/admin/area/out/site/list'),
    /**
     * AREA1.区域列表
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/3588
     */
    AREA_LIST: resolveIPSNodeURLConfig('/admin/area/list'),
    /**
     * AREA2.区域详情
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/3596
     */
    AREA_INFO: resolveIPSNodeURLConfig('/admin/area/info'),
    /**
     * AREA3.区域保存
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/3612
     */
    AREA_SAVE: resolveIPSNodeURLConfig('/admin/area/save'),
    /**
     * AREA4.区域删除
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/3620
     */
    AREA_DELETE: resolveIPSNodeURLConfig('/admin/area/delete'),
    /**
     * AREA4.店铺列表
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/3628
     */
    AREA_SITE_LIST: resolveIPSNodeURLConfig('/admin/site/list'),
    /**
     * 通用获取crm的接口
     */
    IPS_INTER_ACT_TOKEN: resolveIPSNodeURLConfig('/sops/user/wechat/auth/token', HttpMethod.GET),

    /**
     * crm 品牌组列表
     */
    CRM_SYSTEM_BRANDS_GROUP: resolveIPSNodeURLConfig('/scrm/api/system/option/find/system.brandGroup', HttpMethod.GET),
    /**
     * AS100.添加/编辑搜索(推荐)关键词
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/5091
     */
    SITE_KEYWORD_SAVE: resolveIPSNodeURLConfig('/admin/site/keyword/save'),
    /**
     * AS101.搜索(推荐)关键词列表
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/5082
     */
    SITE_KEYWORD_LIST: resolveIPSNodeURLConfig('/admin/site/keyword/list'),
    /**
     * AS102.搜索(推荐)关键词排序
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/5100
     */
    SITE_KEYWORD_SORT: resolveIPSNodeURLConfig('/admin/site/keyword/sort'),
    /**
     * AS103.删除关键词(推荐)
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/5109
     */
    SITE_KEYWORD_DELETE: resolveIPSNodeURLConfig('/admin/site/keyword/delete'),
    /**
     * AS104.小程序综合报表
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/5838
     */
    SITE_GROUP_VISIT_LIST: resolveIPSNodeURLConfig('/admin/site/group/visit/trend'),
    /**
     * AS105.获取通用店铺列表
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/6653
     */
    ADMIN_SITE_AUTH_LIST: resolveIPSNodeURLConfig('/admin/site/auth/list'),

    /**
     * AS106.添加网点组店铺
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/6728
     */
    ADMIN_SITE_GROUP_SITE_ADD: resolveIPSNodeURLConfig('/admin/site/group/site/add'),
    /**
     * AS107.获取云镜店入驻网点列表
     * @see https://yapi.tenyun.runsasoft.com/project/68/interface/api/6794
     */
    REAL_SITE_GROUP_SITE_LIST: resolveIPSNodeURLConfig('/admin/site/group/site/list'),
  };
}
